import ClientBookingNote from "../ClientBookingNote";
import { getCalendarSlotMinutes } from "../calendarSlotDuration";
import RequestedStaffChoice from "./RequestedStaffChoice";
import ResourceAllocationIndicator from "../ResourceAllocationIndicator";
import { isRequestedStaff } from "../../../utils/requestedStaff";
import { containedAppointmentChildStart } from "../../../component/form/containedAppointmentTiming";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// validation Formik
import * as Yup from "yup";
import { appointmentRecurrenceEndingField } from "../appointmentRecurrenceEnding";
import { ErrorMessage, Field, FieldArray, Formik } from "formik";
import { useElements, useStripe } from "@stripe/react-stripe-js";
import config from "../../../config";
import yupconfig from "../../../yupconfig";
import { InputField, ReactSelectField, SelectField, TextareaField, InputPickerField } from "../../../component/form/Field";
import "../../../component/Sweatalert2";
import PropTypes from "prop-types";
import AppointmentResourceFields, { hasRequirementResourceOptions, hasResourceConfigurationProblem, requiresAppointmentResource } from "../../../component/form/AppointmentResourceFields";
import AppointmentSingleResourceSelection from "../../../component/form/AppointmentSingleResourceSelection";
import AppointmentResourceConflict from "./AppointmentResourceConflict";
import { isRecurringMutation, mutationFrameAppointments } from "../calendarMutationRefresh";
import { EditAppointmentForm, appointmentUpdateApi, appointmentDepositStoreApi, appointmentPaymentConfirmApi, appointmentPaymentFailedApi, appointmentFrameRefreshApi, ClientAppointmentListViewApi, appointmentDetailApi, appointmentStoreApi, AddAppointmentForm, EditAppointmentFormData, OpenEditAppointmentRefunds, CancellationReason, GetAppointmentcancelRefundStripe, CalendarEditFormSetActivebtnState, OpenInvoiceStripePayModal, OpenDepositPayTab, GetStripeTokenAppointment, AppointmentDetailModal, AppointmentResourceItemsApi, AppointmentAutoFillFinalData, AddOnServiceButtonRender } from "../../../store/slices/appointmentSlice";
import { servicePriceApi } from "../../../store/slices/serviceSlice";
import DatePicker from "react-multi-date-picker";
import moment from "moment";
import { MinutesToHours, TimePickerDropdown, HoursToMinutes, usercheckAccess } from "helpers/Functions";
import { decimalOnly } from "../../../component/form/Validation";
import { busytimeFrameRefreshApi } from "store/slices/busytimeSlice";
import customToast from "component/Toastr";
import "react-moment";
import { CancellationreasonListViewApi } from "store/slices/cancellationreasonSlice";
import { GetAvailableTime, GetTotalDurationWithPadding } from "component/form/GetAvailableTime";
import { buildAppointmentResourceAvailabilityRequest } from "./appointmentFormUtils";
import { buildAppointmentAvailabilityRequest } from "./calendarAvailabilityFlow";
import { calendarAvailabilityRequests } from "./availabilityRequestCoordinator";
import { AddOnData, AddOnDataRemove, AddOnResourceOptionsApi, AddOnServicePriceApi, AddOnServicesApi, AddonStaffOptionsApi } from "store/slices/addonSlice";
import { AddAnotherData, AddAnotherDataRemove, AddAnotherResourceOptionsApi, AddAnotherServicePriceApi, AddAnotherServicesApi, AddAnotherStaffOptionsApi } from "store/slices/addanotherSlice";
import { useNavigate } from "react-router";
import { OpenCustomAlerts } from "store/slices/commonSlice";
import { getActionError } from "../../../helpers/apiError";
import "react-spinners/BounceLoader";
import { AddonGetAvailableTime } from "component/form/AddonGetAvailableTime";
import { AddAnotherGetAvailableTime } from "component/form/AddAnotherGetAvailableTime";
import { removeChildAvailabilityRow } from "component/form/latestChildAvailability";
import BarLoader from "react-spinners/BarLoader";
import { getAppointmentDepositSummary, selectSafeAppointmentDetail } from "../appointmentDetailSafety";
import {
  appendCurrentAppointmentOption,
  getAppointmentEditDefaults,
} from "../appointmentEditDefaults";
import {
  buildAppointmentDetailRefreshPayload,
  getAppointmentFormHydrationState,
  getAppointmentEditScope,
  isRepeatedAppointment,
  normalizeAppointmentMutationPayload,
} from "../appointmentEditContract";
import {
  extractAppointmentUpdateFailure,
  getAppointmentUpdateResponseMessage,
} from "../appointmentUpdateError";
import {
  appointmentVoucherLabel,
  appointmentPaymentIntent,
  buildAppointmentDepositPayload,
  eligibleAppointmentVouchers,
  findEligibleAppointmentVoucherByCode,
  getAppointmentDepositFormState,
  hasAppointmentDepositSelection,
  stripeConfirmation,
  paymentMethodConfirmationLabel,
} from "./appointmentDeposit";
import { ClientVoucherListViewApi } from "store/slices/clientvoucherSlice";
import { buildAppointmentChildOptionState, buildEmptyAdditionalServiceLine, buildAppointmentServiceFields, normalizeAppointmentAvailabilityDateTime } from "../appointmentServiceFields";
import { childResourceOptionState } from "../../../component/form/appointmentChildResourceOptions";
import { APPOINTMENT_NOTES_MAX_LENGTH, getAppointmentNotesFieldProps } from "../appointmentNotes";
import {
  additionalServiceResourceUnavailableMessage,
  appointmentAdditionalServicesSchema,
  hasUnavailableAdditionalServiceResources,
} from "../appointmentAdditionalServiceValidation";

const renderAppointmentAvailabilityAlert = ({ response, booked: structuredBooked, t }) => {
  const date = response && response.dateof;
  const booked = Array.isArray(structuredBooked)
    ? structuredBooked
    : response && Array.isArray(response.booked)
      ? response.booked
      : [];
  const parsedDate = date ? moment(date, ["YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss"], true) : null;

  return (
    <>
      <p className="mb-2 text-danger salert text-justify">
        {getAppointmentUpdateResponseMessage(response)}
      </p>
      {booked.length > 0 && (
        <>
          <p className="mb-2 text-danger salert text-justify">{t("Staff are available at these times:")}</p>
          {parsedDate && parsedDate.isValid() && (
            <p className="mb-2 text-danger salert text-justify">{parsedDate.format("MMMM DD YYYY")}</p>
          )}
          <ul className="list-unstyled">
            {booked.map((time, index) => {
              const parsedTime = parsedDate && parsedDate.isValid()
                ? moment(`${parsedDate.format("YYYY-MM-DD")}T${time}`, ["YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DDThh:mma"], true)
                : null;
              return (
                <li key={`${time}-${index}`} className="text-danger salert form-text">
                  {parsedTime && parsedTime.isValid() ? parsedTime.format("hh:mm A") : String(time)}
                </li>
              );
            })}
          </ul>
        </>
      )}
    </>
  );
};

const AppointmentEditForm = (props) => {
  useEffect(
    () => () => calendarAvailabilityRequests.cancelOwner("appointmentForm/edit"),
    [],
  );
  const [loading, setLoading] = useState(false);
  const [resourceConflict, setResourceConflict] = useState(false);
  const [resourceRetry, setResourceRetry] = useState(0);
  const [activeLoading, setActiveLoading] = useState({
    addonLoading: false,
    addanotherLoading: false
  });
  const [showModal, setShowModal] = useState(false);
  const [confirmedRefund, setConfirmedRefund] = useState(false);
  useState(false);
  useState(false);
  const [, setBtnConfirmation] = useState(false);
  // const [clientId, setClientId] = useState("");
  const navigate = useNavigate();
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [openStripeSetupModal, setOpenStripeSetupModal] = useState(false);
  const [voucherCode, setVoucherCode] = useState("");
  const [voucherCodeError, setVoucherCodeError] = useState("");
  const stripe = useStripe();
  const elements = useElements();
  const rightDrawerOpened = useSelector((state) => state.appointment.isOpenedEditForm);
  const isOpenDepositPayTab = useSelector((state) => state.appointment.isOpenDepositPayTab);
  const [selectedCancellationReason, setSelectedCancellationReason] = useState('');
  const [showError, setShowError] = useState(false);
  const auth = useSelector((state) => state.auth);
  const currentUser = auth.user;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const notServicesIdRef = useRef();
  const totalAddonServiceCostRef = useRef();
  const totalAddonServiceDurationRef = useRef();
  const notAnotherServicesIdRef = useRef();
  const totalAddanotherServiceCostRef = useRef();
  const totalAddanotherServiceDurationRef = useRef();
  const depositIdempotencyKeyRef = useRef("");
  const isRangeInfo = props.isRangeInfo;
  const page = props.page;
  const isCalendarEditFormSetActivebtnState = useSelector((state) => state.appointment.isCalendarEditFormSetActivebtnState);
  const isStripeTokenAppointment = useSelector((state) => state.appointment.isStripeTokenAppointment);
  const isServiceOption = useSelector((state) => state.service.isServiceOption);
  const isStaffOption = useSelector((state) => state.staff.isStaffOption);
  useSelector(state => state.service.isServicePrice);
  const serviceApiStatus = useSelector((state) => state.service.isApiStatus);
  const detail = useSelector(selectSafeAppointmentDetail);
  const clientVoucherList = useSelector((state) => state.clientvoucher?.isListView);
  const appointmentVoucherOptions = eligibleAppointmentVouchers(clientVoucherList?.data);
  const cancellationreason = useSelector((state) => state.cancellationreason.isListView);
  const cancellationreasonObjectData = cancellationreason && cancellationreason.data ? cancellationreason.data : cancellationreason;
  const isStaffAvailableTimeApi = useSelector((state) => state.staff.isStaffAvailableTime);
  const staffAvailabilityStatus = useSelector((state) => state.staff.isApiStatus?.StaffAvailableTimeApi);
  const staffAvailabilityContext = useSelector((state) => state.staff.staffAvailabilityContext);
  const isAddOn = useSelector((state) => state.addon.isAddOn);
  const isAddOnApiStatus = useSelector((state) => state.addon.isApiStatus);
  const isAddAnother = useSelector((state) => state.addanother.isAddAnother);
  const isAddAnotherApiStatus = useSelector((state) => state.addanother.isApiStatus);
  const role_id = currentUser && currentUser.role_id;
  const single_staff_access = usercheckAccess("dashboard_staff_view", currentUser);
  const singleStaffAccess = role_id === 8 ? '' : (single_staff_access && currentUser && (currentUser.is_owner === 0 || currentUser.is_owner === false)) ? 1 : '';
  const { depositBalance } = getAppointmentDepositSummary(detail);
  const AddOnServiceButtonRenders = useSelector((state) => state.appointment.isAddOnServiceButtonRender);
  const isAppointmentResourceItems = useSelector((state) => state.appointment.isAppointmentResourceItems);
  const appointmentResourceAvailabilityContext = useSelector((state) => state.appointment.appointmentResourceAvailabilityContext);
  const appointmentApiStatus = useSelector((state) => state.appointment.isApiStatus);
  const resourceLookupBlocked = ["loading", "failed"].includes(appointmentApiStatus?.AppointmentResourceItemsApi);
  // Only the option lookups that hydrate a row may hold its spinner.  The
  // availability probes run in the background and can take a long time, so
  // they must not keep "add-on services are loading" on screen for minutes.
  const AddAnotherLoader = (isAddAnotherApiStatus && (isAddAnotherApiStatus.AddAnotherServicePriceApi === "loading")) || (isAddAnotherApiStatus.AddAnotherStaffOptionsApi === "loading");
  const AddOnLoader = (isAddOnApiStatus && (isAddOnApiStatus.AddOnServicePriceApi === "loading")) || (isAddOnApiStatus.AddonStaffOptionsApi === "loading");
  const isFilter = useSelector((state) => state.appointment.isClientAppointmentFilterStatus);
  // useEffect(() => {
  //   setActiveLoading({
  //     addonLoading: detail?.addonservices && detail.addonservices.length > 0,
  //     addanotherLoading: detail?.addanotherservices && detail.addanotherservices.length > 0
  //   });
  //   if (detail.addonservices) {
  //     detail.addonservices.map((item, getFieldNameIndex) => {
  //       dispatch(AddOnServicePriceApi({ parent_service_id: detail.service_id, parent_staff_id: detail.staff_id, service_id: item.service_id, index_id: getFieldNameIndex })).then((action) => {
  //         if (action.meta.requestStatus === "fulfilled") {
  //           let service = action.payload;
  //           // let indexID = getFieldNameIndex + 1;
  //           let indexID = getFieldNameIndex;
  //           const addOnData = isAddOn.find((event) => event.id === indexID);
  //           let addonobj = { ...addOnData, serviceprice: action.payload, duration: service.duration };


  //           dispatch(AddonStaffOptionsApi({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, service_id: service.id, pagetype: "Booking" })).then((action1) => {
  //             if (action1.meta.requestStatus === "fulfilled") {
  //               if (addonobj) {
  //                 setActiveLoading(false)
  //                 dispatch(AddOnData({ ...addonobj, staff: action1.payload }));
  //               }
  //             }
  //           });

  //           dispatch(AddOnResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: service.id, pagetype: "Booking" })).then((action1) => {
  //             if (action1.meta.requestStatus === "fulfilled") {
  //               if (addonobj) {
  //                 setActiveLoading(false)
  //                 dispatch(AddOnData({ ...addonobj, resource_items: action1.payload }));
  //               }
  //             }
  //           });

  //           // const addOnResourceOptionsAction = dispatch(AddOnResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: service.id, pagetype: "Booking" }));
  //           // const addOnStaffOptionsAction = dispatch(AddonStaffOptionsApi({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, service_id: service.id, pagetype: "Booking" }));

  //           // Promise.all([addOnResourceOptionsAction, addOnStaffOptionsAction]).then(([action1, action2]) => {
  //           //   setActiveLoading((prevLoading) => ({ ...prevLoading, addonLoading: false }));
  //           //   if (action1.meta.requestStatus === "fulfilled" && action2.meta.requestStatus === "fulfilled") {
  //           //     if (addonobj) {
  //           //       dispatch(AddOnData({ ...addonobj, staff: action2.payload, resource_items: action1.payload }));
  //           //     }
  //           //   }
  //           // });
  //         }
  //       });
  //     });
  //   }
  //   if (detail && detail.addanotherservices && detail.addanotherservices.length > 0) {
  //     detail.addanotherservices.map((item, getFieldNameIndex) => {
  //       dispatch(AddAnotherServicePriceApi({ parent_service_id: detail.service_id, parent_staff_id: detail.staff_id, service_id: item.service_id, index_id: getFieldNameIndex })).then((action) => {
  //         // dispatch(AddAnotherServicePriceApi({ parent_service_id: detail.service_id, parent_staff_id: detail.staff_id, service_id: item.service_id, index_id: getFieldNameIndex })).then((action) => {
  //         if (action.meta.requestStatus === "fulfilled") {
  //           let service = action.payload;
  //           let indexID = getFieldNameIndex + 1;
  //           const addanotherData = isAddAnother.find((event) => event.id === indexID);
  //           let addanotherobj = { ...addanotherData, serviceprice: action.payload, duration: service.duration };
  //           const addAnotherResourceOptionsAction = dispatch(AddAnotherResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: service.id, pagetype: "Booking", }));
  //           const addAnotherStaffOptionsAction = dispatch(AddAnotherStaffOptionsApi({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, service_id: service.id, pagetype: "Booking", }));
  //           Promise.all([addAnotherResourceOptionsAction, addAnotherStaffOptionsAction]).then(([action1, action2]) => {
  //             setActiveLoading((prevLoading) => ({ ...prevLoading, addanotherLoading: false }));
  //             if (action1.meta.requestStatus === "fulfilled" && action2.meta.requestStatus === "fulfilled") {
  //               if (addanotherobj) {
  //                 dispatch(AddAnotherData({ ...addanotherobj, staff: action2.payload, resource_items: action1.payload }));
  //               }
  //             }
  //           });
  //         }
  //       });
  //     });
  //   }
  // }, [detail]);

  useEffect(() => {
    // The calendar hides the add-on block until a primary service with
    // add-ons is picked.  Edit hydration selects the primary service
    // programmatically, so it has to decide the same thing itself or the
    // editor never shows the add-ons already on the appointment.
    if (detail && detail.service_id) {
      if (detail.addonservices && detail.addonservices.length > 0) {
        dispatch(AddOnServiceButtonRender(true));
      } else {
        Promise.resolve(dispatch(servicePriceApi({ service_id: detail.service_id }))).then((action) => {
          const addOnServiceCount = action?.meta?.requestStatus === "fulfilled" && action.payload && action.payload.add_on_services_count ? Number(action.payload.add_on_services_count) : 0;
          dispatch(AddOnServiceButtonRender(addOnServiceCount > 0));
        }).catch(() => {});
      }
    }
    setActiveLoading({
      addonLoading: detail?.addonservices && detail.addonservices.length > 0,
      addanotherLoading: detail?.addanotherservices && detail.addanotherservices.length > 0
    });
    const remove_addon = detail?.addonservices?.length > 0
      ? detail?.addonservices.map(item => item.id)
      : [];

    const remove_addanother = detail?.addanotherservices?.length > 0
      ? detail?.addanotherservices.map(item => item.id)
      : [];

    if (detail.addonservices) {
      detail.addonservices.map((item, getFieldNameIndex) => {
        const indexID = getFieldNameIndex + 1;
        const addOnData = isAddOn.find((event) => event.id === indexID);
        // Commit the appointment's stored child staff before asking the price
        // API for enrichment.  The stored staff is authoritative, and the
        // optional price/staff lookups can be rejected (for example when the
        // add-on service is now inactive), which used to leave the row's staff
        // select empty and the row loading forever.
        dispatch(AddOnData(buildAppointmentChildOptionState({
          existing: { ...(addOnData || {}), id: indexID },
          id: indexID,
          service: item,
          resourceOptions: null,
          parentStaffId: detail.staff_id,
          parentStaffOptions: staffOptionsData,
        })));
        dispatch(AddOnServicePriceApi({ parent_service_id: detail.service_id, parent_staff_id: detail.staff_id, service_id: item.service_id, index_id: getFieldNameIndex })).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            let service = action.payload;
            // console.log('item',item, addOnData);
            const serviceFields = buildAppointmentServiceFields(item, detail.staff_id);
            const childStartDatetime = normalizeAppointmentAvailabilityDateTime(item.start_datetime);
            let addonobj = {
              ...(addOnData || {}),
              id: indexID,
              serviceprice: action.payload,
              resource_options_loaded: false,
              duration: serviceFields.duration,
              padding_time: serviceFields.padding_time,
            };

            const addonservices = detail && detail.addonservices.length > 0 ? detail.addonservices.slice(0, getFieldNameIndex) : "";



            if (addonservices && addonservices.length > 0) {
              const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
                // Check if sduration.durationWithPadding is a valid duration
                const duration = moment.duration(sduration.durationWithPadding);
                if (duration.isValid()) {
                  const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                  return sum.add(sumDurationWithPadding);
                }
                return sum;
              }, moment.duration(0));
              // console.log('isNotInResourceIds',isNotInResourceIds);

              const parentAppointmentDuration = item && item.durationWithPadding ? item.durationWithPadding : "";
              const duration1 = moment.duration(parentAppointmentDuration);
              const duration2 = totalAddOnDurationWithPadding;

              // Check if each duration is valid before using it
              const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
              const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;

              const totalMinutes = minutes1 + minutes2;
              const hours = Math.floor(totalMinutes / 60);
              const minutes = totalMinutes % 60;

              const sumDuration = moment({ hours, minutes });
              const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

              const durationMoment = moment.duration(SumOfDuration);

              const appointmentStartDateTime = moment(`${detail?.start_datetime}`, "dddd, DD MMMM YYYY HH:mm");
              appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
              // isNotInResourceIds.push(form.values.resource_item_id);
            } else {
              const appointmentStartDateTime = moment(`${detail?.start_datetime}`, "dddd, DD MMMM YYYY HH:mm");
              const durationMoment = moment.duration(detail?.durationWithPadding);

              appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
            }

            const availebleTimeObj = {
              appointment_id: item && item.id ? item.id : "",
              // Detail child rows may omit parent_id; validate the whole open booking.
              parent_id: detail.id || item?.parent_id || "",
              busytime_id: "",
              dateof: detail && detail.dateof ? detail.dateof : "",
              start_datetime: childStartDatetime,
              duration: serviceFields.duration,
              padding_time: serviceFields.padding_time,
              durationWithPadding: serviceFields.durationWithPadding,
              listview: "Appointment",
              salon_id: item && item.salon_id ? item.salon_id : "",
              service_id: item && item.service_id ? item.service_id : "",
              staff_id: serviceFields.staff_id,
              resource_item_id: item && item.resource_item_id ? item.resource_item_id : "",
              parentAppointmentEndTime: childStartDatetime,
              // uid: 1,
              remove_addon: remove_addon || [],
              remove_addanother: remove_addanother || [],
              formtype: "appointmentForm",
              appointment_type: "addonservices",
              formName: "appointmentForm/edit/addon/resource_item_id"
            }
            const addOnResourceOptionsAction = dispatch(AddOnResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: service.id, availebleTimeObj, pagetype: "Booking", formtype: "edit_appointment", formName: "appointmentForm/edit/addon/resource_item_id" }));
            const addOnStaffOptionsAction = dispatch(AddonStaffOptionsApi({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, service_id: service.id, pagetype: "Booking", formName: "appointmentForm/edit/addon/staff_id", availebleTimeObj }));
            Promise.all([addOnResourceOptionsAction, addOnStaffOptionsAction]).then(([action1, action2]) => {
              setActiveLoading((prevLoading) => ({ ...prevLoading, addonLoading: false }));
              const addOnResourceLoaded = action1.meta.requestStatus === "fulfilled";
              // A multi-resource service answers with grouped
              // ``resource_requirements``; normalize both shapes so the edit
              // form renders the same controls the create form already does.
              const addOnResourceState = childResourceOptionState(
                addOnResourceLoaded ? action1.payload : [],
                item,
              );
              dispatch(AddOnData(buildAppointmentChildOptionState({
                existing: addonobj,
                id: indexID,
                service: item,
                parentStaffId: detail.staff_id,
                parentStaffOptions: staffOptionsData,
                staffOptions: action2.meta.requestStatus === "fulfilled" ? action2.payload : undefined,
                resourceOptions: addOnResourceLoaded ? addOnResourceState.resourceOptions : undefined,
              })));
            }).catch(() => {
              setActiveLoading((prevLoading) => ({ ...prevLoading, addonLoading: false }));
            });
          } else {
            setActiveLoading((prevLoading) => ({ ...prevLoading, addonLoading: false }));
          }
        }).catch(() => {
          setActiveLoading((prevLoading) => ({ ...prevLoading, addonLoading: false }));
        });
      });
    }
    if (detail && detail.addanotherservices && detail.addanotherservices.length > 0) {
      detail.addanotherservices.map((item, getFieldNameIndex) => {
        const indexID = getFieldNameIndex + 1;
        const addanotherData = isAddAnother.find((event) => event.id === indexID);
        // Mirror the add-on hydration: the stored child staff must survive a
        // rejected price lookup so the row's staff select is never blank.
        dispatch(AddAnotherData(buildAppointmentChildOptionState({
          existing: { ...(addanotherData || {}), id: indexID },
          id: indexID,
          service: item,
          resourceOptions: null,
          parentStaffId: detail.staff_id,
          parentStaffOptions: staffOptionsData,
        })));
        dispatch(AddAnotherServicePriceApi({ parent_service_id: detail.service_id, parent_staff_id: detail.staff_id, service_id: item.service_id, index_id: getFieldNameIndex })).then((action) => {
          // dispatch(AddAnotherServicePriceApi({ parent_service_id: detail.service_id, parent_staff_id: detail.staff_id, service_id: item.service_id, index_id: getFieldNameIndex })).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            let service = action.payload;
            const serviceFields = buildAppointmentServiceFields(item, detail.staff_id);
            const childStartDatetime = normalizeAppointmentAvailabilityDateTime(item.start_datetime);
            let addanotherobj = {
              ...(addanotherData || {}),
              id: indexID,
              serviceprice: action.payload,
              resource_options_loaded: false,
              duration: serviceFields.duration,
              padding_time: serviceFields.padding_time,
            };

            // const addonservices = [...detail.addonservices];
            //   const addanotherservices = [...detail.addanotherservices];

            //   let parentAppointmentEndTime = "";
            //   let isNotInResourceIds = [];
            //   if (detail.resource_item_id) {
            //     isNotInResourceIds.push(detail.resource_item_id);
            //   }
            //   const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
            //     // Check if sduration.durationWithPadding is a valid duration
            //     const duration = moment.duration(sduration.durationWithPadding);

            //     if (duration.isValid()) {
            //       const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
            //       if (sduration.resource_item_id) {
            //         isNotInResourceIds.push(sduration.resource_item_id);
            //       }
            //       return sum.add(sumDurationWithPadding);
            //     }
            //     return sum;
            //   }, moment.duration(0));
            //   // console.log('form',  addanotherservices);
            //   // if (addanotherservices && addanotherservices.length > 1) {
            //   //   addanotherservices.pop();

            //   if (addanotherservices && addanotherservices.length > 1) {
            //     const addanotherservicesFilter = addanotherservices.slice(0, getFieldNameIndex);
            //     //console.log('addanotherservicesFilter', getFieldNameIndex, addanotherservicesFilter);
            //     const totalAddAnotherDurationWithPadding = addanotherservicesFilter.length > 0 && addanotherservicesFilter.reduce((sum, sduration) => {
            //       // Check if sduration.durationWithPadding is a valid duration
            //       const duration = moment.duration(sduration.durationWithPadding);
            //       if (duration.isValid()) {
            //         const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
            //         if (sduration.resource_item_id) {
            //           isNotInResourceIds.push(sduration.resource_item_id);
            //         }
            //         return sum.add(sumDurationWithPadding);
            //       }
            //       return sum;
            //     }, moment.duration(0));

            //     const parentAppointmentDuration = detail.durationWithPadding;
            //     const duration1 = moment.duration(parentAppointmentDuration);
            //     const duration2 = totalAddOnDurationWithPadding;
            //     const duration3 = totalAddAnotherDurationWithPadding;

            //     // Check if each duration is valid before using it
            //     const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
            //     const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;
            //     const minutes3 = duration3 && duration3.isValid() ? duration3.asMinutes() : 0;

            //     const totalMinutes = minutes1 + minutes2 + minutes3;
            //     const hours = Math.floor(totalMinutes / 60);
            //     const minutes = totalMinutes % 60;

            //     const sumDuration = moment({ hours, minutes });
            //     const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

            //     const durationMoment = moment.duration(SumOfDuration);

            //     const appointmentStartDateTime = moment(`${detail.start_datetime}`, "dddd, DD MMMM YYYY HH:mm");
            //     parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');

            //   } else {
            //     const appointmentStartDateTime = moment(`${detail.start_datetime}`, "dddd, DD MMMM YYYY HH:mm");
            //     const duration1 = moment.duration(detail.durationWithPadding);
            //     const duration2 = totalAddOnDurationWithPadding;
            //     // Check if each duration is valid before using it
            //     const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
            //     const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;

            //     const totalMinutes = minutes1 + minutes2;
            //     const hours = Math.floor(totalMinutes / 60);
            //     const minutes = totalMinutes % 60;

            //     const sumDuration = moment({ hours, minutes });
            //     const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

            //     const durationMoment = moment.duration(SumOfDuration);
            //     parentAppointmentEndTime = appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
            //   }

            const availebleTimeObj = {
              appointment_id: item && item.id ? item.id : "",
              // Detail child rows may omit parent_id; validate the whole open booking.
              parent_id: detail.id || item?.parent_id || "",
              busytime_id: "",
              dateof: detail && detail.dateof ? detail.dateof : "",
              start_datetime: childStartDatetime,
              duration: serviceFields.duration,
              padding_time: serviceFields.padding_time,
              durationWithPadding: serviceFields.durationWithPadding,
              listview: "Appointment",
              salon_id: item && item.salon_id ? item.salon_id : "",
              service_id: item && item.service_id ? item.service_id : "",
              staff_id: serviceFields.staff_id,
              resource_item_id: item && item.resource_item_id ? item.resource_item_id : "",
              parentAppointmentEndTime: childStartDatetime,
              // uid: 1,
              remove_addon: remove_addon || [],
              remove_addanother: remove_addanother || [],
              formtype: "appointmentForm",
              appointment_type: "addanotherservices",
            }
            const addAnotherResourceOptionsAction = dispatch(AddAnotherResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: service.id, pagetype: "Booking", formtype: "edit_appointment", formName: "appointmentForm/edit/addanother/resource_item_id", availebleTimeObj: { ...availebleTimeObj, formName: "appointmentForm/edit/addanother/resource_item_id" } }));
            const addAnotherStaffOptionsAction = dispatch(AddAnotherStaffOptionsApi({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, service_id: service.id, pagetype: "Booking", formName: "appointmentForm/edit/addanother/staff_id", availebleTimeObj: { ...availebleTimeObj, formName: "appointmentForm/edit/addanother/staff_id" } }));
            Promise.all([addAnotherResourceOptionsAction, addAnotherStaffOptionsAction]).then(([action1, action2]) => {
              setActiveLoading((prevLoading) => ({ ...prevLoading, addanotherLoading: false }));
              dispatch(AddAnotherData(buildAppointmentChildOptionState({
                existing: addanotherobj,
                id: indexID,
                service: item,
                parentStaffId: detail.staff_id,
                parentStaffOptions: staffOptionsData,
                staffOptions: action2.meta.requestStatus === "fulfilled" ? action2.payload : undefined,
                resourceOptions: action1.meta.requestStatus === "fulfilled" ? action1.payload : undefined,
              })));
            }).catch(() => {
              setActiveLoading((prevLoading) => ({ ...prevLoading, addanotherLoading: false }));
            });
          } else {
            setActiveLoading((prevLoading) => ({ ...prevLoading, addanotherLoading: false }));
          }
        }).catch(() => {
          setActiveLoading((prevLoading) => ({ ...prevLoading, addanotherLoading: false }));
        });
      });
    }
  }, [detail]);

  const TimePickerOption = TimePickerDropdown(getCalendarSlotMinutes(currentUser?.salon?.slot_time_hourly)).map(({ value }) => {
    const time = moment(value, "h:mma").format("hh:mma");
    return { id: time, value: time };
  });


  const clearAppointmentDepositState = () => {
    depositIdempotencyKeyRef.current = "";
    dispatch(OpenDepositPayTab(false));
    dispatch(CalendarEditFormSetActivebtnState(""));
    dispatch(GetStripeTokenAppointment(""));
  };

  const handleEditAppointmentForm = () => {
    clearAppointmentDepositState();
    dispatch(EditAppointmentForm(true));
    setTimeout(() => {
      dispatch(EditAppointmentForm(""));
    }, config.modalCloseTimeOut);
  };

  const initialValues = {
    form_types: "edit_appointment",
    is_requested: null,
    isDepositTabOpen: "",
    client_id: "",
    service_id: "",
    staff_id: "",
    dateof: "",
    start_time: "",
    duration: "",
    padding_time: "",
    durationWithPadding: "",
    add_on_within_original_time: false,
    cost: "",
    repeats: "",
    booking_notes: "",
    status: "",
    status_manage: "",
    repeats: "",
    repeat_time: "",
    repeat_time_option: "",
    ending: "",
    resource_id: "",
    resource_item_id: "",
    resource_allocations: [],
    resource_required: false,
    addonservices: [],
    addanotherservices: [],
    service_deposit: [],
    repeat_appointment: "",
    edit_scope: "individual",
    occurrence_start_datetime: "",
    previous_deposit_paid: "",
    type: "UpdateAppointment",
    deposit_payment_by: "",
    stripe_token_id: "",
    voucher_to_id: "",
    totaldeposit: "0.00",
    prev_start_datetime: "",
    deposit_booked_online: [],
    remove_addanother: [],
    remove_addon: [],
  };

  const validationSchema = Yup.object().shape({
    client_id: Yup.lazy((val) => (Array.isArray(val) ? Yup.array().of(Yup.string()).nullable().min(1).required() : Yup.string().nullable().label(t("Client")).required())),
    service_id: Yup.lazy((val) => (Array.isArray(val) ? Yup.array().of(Yup.string()).nullable().min(1).required() : Yup.string().nullable().label(t("Service")).required())),
    staff_id: Yup.lazy((val) => (Array.isArray(val) ? Yup.array().of(Yup.string()).nullable().min(1).required() : Yup.string().nullable().label(t("Staff")).required())),
    dateof: Yup.date().label(t("Date")).required(),
    // .min(new Date(Date.now() - 86400000), t("Date cannot be in the past")),
    start_time: Yup.string().trim().label(t("Start Time")).required(),
    duration: Yup.string().trim().matches(config.duration_pattern, t(config.duration_HM_error)).label(t("Duration")).required(),
    cost: Yup.string().trim().label(t("Cost")).required().test("Decimal only", t("The field should have decimal only"), decimalOnly),
    repeats: Yup.string().trim().label(t("Repeats")).required(),
    booking_notes: Yup.string().trim().max(APPOINTMENT_NOTES_MAX_LENGTH, t("Booking notes cannot exceed 10000 characters.")).label(t("Booking Notes")),
    repeats: Yup.string().trim().label(t("Repeats")).required(),
    repeat_time: Yup.string()
      .nullable()
      .when("repeats", {
        is: "Yes",
        then: () => Yup.string().trim().label(t("Repeat time")).required(t("Required")).test("Digits only", t("Digits only"), decimalOnly),
      }),
    repeat_time_option: Yup.string()
      .nullable()
      .when("repeats", {
        is: "Yes",
        then: () => Yup.string().trim().label(t("Repeat time option")).required(t("Required")),
      }),
    ending: appointmentRecurrenceEndingField(t),
    totaldeposit: Yup.number()
      .nullable()
      .when(["isDepositTabOpen"], {
        is: (tabOpen) => {
          if (tabOpen) {
            return true;
          } else {
            return false;
          }
        },
        then: () => Yup.number()
          .required(t("Deposit is required"))
          .typeError(t("Total deposit must be a number"))
          .min(0.0, t("Total deposit must be at least 0"))
          .test('is-not-negative', t("Negative values are not allowed"), value => value >= 0.0),
      }),
    resource_item_id: Yup.string()
      .nullable()
      .when(["service_id", "resource_required"], {
        is: (service, resourceRequired) => {
          if (service && resourceRequired) {
            return true;
          } else {
            return false;
          }
        },
        then: () => Yup.string().trim().label(t("Resource")).required(),
      }),
    addonservices: appointmentAdditionalServicesSchema(t),
    addanotherservices: appointmentAdditionalServicesSchema(t),
    // ending: Yup.date()
    //   .label(t("Ending (Optional)"))
    //   .min(Yup.ref("dateof"), t("Ending date must be after the start date"))
    //   .test("is-valid-date", t("Ending date must be after the start date"), function (value) {
    //     const { path, createError } = this;
    //     const dateof = this.resolve(Yup.ref("dateof"));
    //     const minimumDate = new Date(dateof);
    //     minimumDate.setDate(minimumDate.getDate() + 7);
    //     if (!value || value >= minimumDate) {
    //       return true;
    //     }

    //     return createError({ path, message: t("Ending date must be after the start date") });
    //   })
    //   .min(new Date(), t("Date cannot be in the past")),
  });
  yupconfig();

  const showAppointmentDepositError = (action, { setErrors, setStatus, setSubmitting }) => {
    const { response, errors } = getActionError(action);
    const message = response && response.message
      ? response.message
      : "Unable to save the appointment deposit.";
    dispatch(OpenCustomAlerts({
      isOpen: "open",
      errors: <p className="mb-2 text-danger salert text-justify">{message}</p>,
    }));
    setErrors(errors || {});
    setStatus({ success: false, message });
    setSubmitting(false);
    setLoading(false);
  };

  const finishAppointmentDeposit = (values, response, { setStatus, setSubmitting }) => {
    const detailRefreshPayload = buildAppointmentDetailRefreshPayload({
      values,
      response,
      detail,
    });
    setStatus({ success: true });
    dispatch(servicePriceApi({ service_id: "" }));
    dispatch(EditAppointmentForm(true));
    setTimeout(() => {
      dispatch(EditAppointmentForm(""));
    }, config.modalCloseTimeOut);
    dispatch(ClientAppointmentListViewApi({
      client_id: values.client_id || detail?.client_id,
      client: values.client_id || detail?.client_id,
      filter: isFilter,
      page_name: "client_appointment",
    }));
    if (isRangeInfo) {
      dispatch(appointmentFrameRefreshApi({ range: isRangeInfo, appointments: [values, response] }));
      dispatch(appointmentDetailApi(detailRefreshPayload));
      dispatch(busytimeFrameRefreshApi({ range: isRangeInfo, appointments: [values, response] }));
    }
    customToast.success(`${t("Deposit added successfully")}`);
    clearAppointmentDepositState();
    setSubmitting(false);
    setLoading(false);
  };

  const failAppointmentDeposit = (message, { setErrors, setStatus, setSubmitting }) => {
    setErrors(message);
    setStatus({ success: false, message });
    setSubmitting(false);
    setLoading(false);
  };

  const handleAppointmentDepositSubmit = (values, formikHelpers) => {
    const { setErrors, setStatus, setSubmitting } = formikHelpers;
    const isStripePayment = values.deposit_payment_by === "StripeCreditCard";
    const stripePaymentMethodId = values.stripe_token_id;

    if (isStripePayment && (!stripe || !elements)) {
      failAppointmentDeposit(
        "Stripe is unavailable. Please wait for Stripe to load and try again.",
        formikHelpers,
      );
      return;
    }
    if (isStripePayment && !stripePaymentMethodId) {
      failAppointmentDeposit("Please provide a Stripe payment method.", formikHelpers);
      return;
    }
    if (values.deposit_payment_by === "Voucher" && !values.voucher_to_id) {
      failAppointmentDeposit("Please select a voucher for this deposit.", formikHelpers);
      return;
    }
    if (!depositIdempotencyKeyRef.current) {
      const randomPart = typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2);
      depositIdempotencyKeyRef.current = `appointment-edit-deposit-${Date.now()}-${randomPart}`;
    }

    dispatch(appointmentDepositStoreApi(
      buildAppointmentDepositPayload(values, depositIdempotencyKeyRef.current),
    )).then((action) => {
      if (action.meta.requestStatus !== "fulfilled") {
        showAppointmentDepositError(action, formikHelpers);
        return;
      }

      const response = action.payload;
      if (!isStripePayment) {
        finishAppointmentDeposit(values, response, formikHelpers);
        return;
      }

      const paymentIntent = appointmentPaymentIntent(response);
      const confirmation = stripeConfirmation(response, stripePaymentMethodId);
      if (!paymentIntent.id || !confirmation) {
        failAppointmentDeposit(
          "Stripe did not return a payment intent. Please retry.",
          formikHelpers,
        );
        return;
      }

      stripe
        .confirmCardPayment(confirmation.clientSecret, {
          payment_method: confirmation.payment_method,
        })
        .then((result) => {
          if (result.error) {
            setErrors(`Payment failed ${result.error.message}`);
            setStatus({ success: false, message: result.error.message });
            dispatch(appointmentPaymentFailedApi({
              ...response,
              error: {
                ...result.error,
                payment_intent: { id: paymentIntent.id },
              },
            }));
            setSubmitting(false);
            setLoading(false);
            return;
          }

          const confirmedPaymentIntent = result.paymentIntent;
          if (!confirmedPaymentIntent || confirmedPaymentIntent.status !== "succeeded") {
            failAppointmentDeposit("Stripe did not confirm the payment.", formikHelpers);
            return;
          }

          dispatch(appointmentPaymentConfirmApi({
            ...response,
            paymentIntent: {
              id: confirmedPaymentIntent.id,
              status: confirmedPaymentIntent.status,
            },
          })).then((confirmationAction) => {
            if (confirmationAction.meta.requestStatus === "fulfilled") {
              finishAppointmentDeposit(values, response, formikHelpers);
            } else {
              showAppointmentDepositError(confirmationAction, formikHelpers);
            }
          });
        })
        .catch((error) => {
          failAppointmentDeposit(error.message || "Payment failed. Please retry.", formikHelpers);
        });
    }).catch((error) => {
      failAppointmentDeposit(error.message || "Unable to save the appointment deposit.", formikHelpers);
    });
  };

  const validateAppointmentDeposit = (formik) => {
    const amount = Number(formik.values.totaldeposit);
    if (!Number.isFinite(amount) || amount <= 0) {
      formik.setFieldTouched("totaldeposit", true, false);
      formik.setFieldError("totaldeposit", t("Enter a deposit greater than zero."));
      return false;
    }
    if (!hasAppointmentDepositSelection(formik.values)) {
      formik.setFieldTouched("deposit_payment_by", true, false);
      formik.setFieldError("deposit_payment_by", t("Select a deposit payment method."));
      return false;
    }
    return true;
  };

  const handleAppointmentDepositSave = (formik) => {
    formik.setSubmitting(true);
    setLoading(true);
    handleAppointmentDepositSubmit(formik.values, formik);
  };

  const handleAppointmentSubmit = (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
    if (resourceConflict || resourceLookupBlocked) {
      setSubmitting(false);
      return;
    }
    setLoading(true);
    const formikHelpers = { setErrors, setStatus, setSubmitting, resetForm };
    // A deposit is persisted through its own payment workflow, but the edited
    // appointment still has to be saved first: the update API rejects payloads
    // that carry deposit fields, so the two requests cannot be merged.
    const depositSelected = hasAppointmentDepositSelection(values);
    const mutationValues = {
      ...normalizeAppointmentMutationPayload(values),
      repeat_scope: getAppointmentEditScope(values),
      occurrence_start_datetime: values.occurrence_start_datetime,
    };
    try {
      if (
        mutationValues &&
        isRepeatedAppointment(mutationValues.repeat_appointment) &&
        mutationValues.repeat_scope === "series"
      ) {
        if (depositSelected) {
          handleAppointmentDepositSubmit(values, formikHelpers);
          return;
        }
        dispatch(appointmentStoreApi(mutationValues)).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            // let data = action.payload;
            // let startdate = data.date + "T" + data.start_time;
            setStatus({ success: true });
            resetForm();
            dispatch(servicePriceApi({ service_id: "" }));
            dispatch(AddAppointmentForm(true));
            setTimeout(() => {
              dispatch(AddAppointmentForm(""));
            }, config.modalOpenTimeOut);
            dispatch(ClientAppointmentListViewApi({ client_id: mutationValues.client_id, client: mutationValues.client_id, filter: isFilter, page_name: "client_appointment" }));
            if (isRangeInfo) {
              dispatch(appointmentFrameRefreshApi({ range: isRangeInfo, appointments: mutationFrameAppointments([mutationValues, action.payload], { recurring: isRecurringMutation(mutationValues) }) }));
              dispatch(busytimeFrameRefreshApi({ range: isRangeInfo, appointments: [mutationValues, action.payload] }));
            }
            customToast.success(`${t("Appointment updated successfully")}`);
            setLoading(false);
          } else if (action.meta.requestStatus === "rejected") {
            const { status, errors, response, message, booked } = extractAppointmentUpdateFailure(action);
            if (status === 422) {
              const NotifyContent = () => {
                return (
                  <>
                    <p className="mb-2 text-light text-justify">{message}</p>
                    <ul className="list-unstyled">
                      {errors &&
                        Object.keys(errors).map((a, n) => {
                          if (errors[a].length > 0) {
                            return (
                              <>
                                {errors[a].map((as, ns) => {
                                  return (
                                    <li key={n + "-" + ns} className="text-light form-text text-start">
                                      {as}
                                    </li>
                                  );
                                })}
                              </>
                            );
                          }
                        })}
                    </ul>
                  </>
                );
              };
              dispatch(OpenCustomAlerts({ isOpen: "open", errors: NotifyContent() }));
              setErrors(errors);
              setStatus({ success: false });
              setLoading(false);
            } else if (status === 410) {
              dispatch(OpenCustomAlerts({
                isOpen: "open",
                errors: renderAppointmentAvailabilityAlert({ response, booked, t }),
              }));
              setStatus({ warning: message, booked });
              setLoading(false);
            } else {
              dispatch(OpenCustomAlerts({
                isOpen: "open",
                errors: (
                    <>
                      <p className="mb-2 text-danger salert text-justify">
                        {getAppointmentUpdateResponseMessage(response)}
                      </p>
                    </>
                ),
              }));
              setLoading(false);
            }
            setSubmitting(false);
          }
        });
      } else {
        dispatch(appointmentUpdateApi(mutationValues)).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            if (depositSelected) {
              handleAppointmentDepositSubmit(
                { ...values, id: action.payload?.id || values.id },
                formikHelpers,
              );
              return;
            }
            const payload = action.payload;
            const detailRefreshPayload = buildAppointmentDetailRefreshPayload({
              values: mutationValues,
              response: payload,
              detail,
            });
            setStatus({ success: true });
            dispatch(servicePriceApi({ service_id: "" }));
            dispatch(EditAppointmentForm(true));
            setTimeout(() => {
              dispatch(EditAppointmentForm(""));
            }, config.modalCloseTimeOut);
            dispatch(ClientAppointmentListViewApi({ client_id: mutationValues.client_id || detail?.client_id, client: mutationValues.client_id || detail?.client_id, filter: isFilter, page_name: "client_appointment" }));
            if (isRangeInfo) {
              dispatch(appointmentFrameRefreshApi({ range: isRangeInfo, appointments: mutationFrameAppointments([mutationValues, payload], { recurring: isRecurringMutation(mutationValues) }) }));
              dispatch(appointmentDetailApi(detailRefreshPayload));
              dispatch(busytimeFrameRefreshApi({ range: isRangeInfo, appointments: [mutationValues, payload] }));
            }
            customToast.success(`${t("Appointment updated successfully")}`);
            setLoading(false);
          } else if (action.meta.requestStatus === "rejected") {
            const { status, errors, response, message, booked } = extractAppointmentUpdateFailure(action);
            if (status === 422) {
              dispatch(
                OpenCustomAlerts({
                  isOpen: "open",
                  errors: (
                    <>
                      <p className="mb-2 text-danger salert text-justify">{message}</p>
                      <ul className="list-unstyled">
                        {errors &&
                          Object.keys(errors).map((a, n) => {
                            if (errors[a].length > 0) {
                              return (
                                <>
                                  {errors[a].map((as, ns) => {
                                    return (
                                      <li key={n + "-" + ns} className="text-danger salert form-text text-start">
                                        {as}
                                      </li>
                                    );
                                  })}
                                </>
                              );
                            }
                          })}
                      </ul>
                    </>
                  )
                })
              );
              setErrors(errors);
              setStatus({ success: false });
              setLoading(false);
            } else if (status === 410) {
              dispatch(OpenCustomAlerts({
                isOpen: "open",
                errors: renderAppointmentAvailabilityAlert({ response, booked, t }),
              }));
              setStatus({ warning: message, booked });
              setLoading(false);
            } else {
              dispatch(OpenCustomAlerts({
                isOpen: "open",
                errors: (
                    <>
                      <p className="mb-2 text-danger salert text-justify">
                        {getAppointmentUpdateResponseMessage(response)}
                      </p>
                    </>
                ),
              }));
              setLoading(false);
            }
            setSubmitting(false);
          }
        });
      }
    } catch (err) {
      setErrors(err.message);
      setStatus({ success: false });
      setLoading(false);
    }
  };

  const editDefaults = getAppointmentEditDefaults(detail);
  // The loading/error early-return below happens after the hydration effects
  // have already been registered, so these option lists have to be
  // initialised before it.  A `const` declared on the far side of that return
  // is still in its temporal dead zone on the loading render pass, and the
  // effects that read it then throw "Cannot access 'staffOptionsData' before
  // initialization", which takes the whole calendar route down.
  const serviceOptionsData = appendCurrentAppointmentOption(
    isServiceOption,
    editDefaults.service_id,
    detail?.service?.name || "",
  );
  const staffOptionsData = appendCurrentAppointmentOption(
    isStaffOption,
    editDefaults.staff_id,
    [detail?.staff?.first_name, detail?.staff?.last_name].filter(Boolean).join(" "),
  );
  const hydration = getAppointmentFormHydrationState({
    detail,
    appointmentStatus: appointmentApiStatus?.appointmentDetailApi,
    serviceStatus: serviceApiStatus?.serviceOptions,
    serviceOptions: isServiceOption,
    requireService: true,
  });
  if (!hydration.interactive) {
    const failed = hydration.phase === "error";
    return (
      <div className={"drawer client-editappoinment " + rightDrawerOpened} id="addappoinment-drawer" aria-busy={!failed}>
        <div className="drawer-wrp p-4">
          <h2>{t("Edit Appointment")}</h2>
          <p role={failed ? "alert" : "status"}>
            {failed ? t("Unable to load appointment details.") : t("Loading appointment details…")}
          </p>
          <button type="button" className="btn btn-secondary" onClick={handleEditAppointmentForm}>{t("Cancel")}</button>
        </div>
      </div>
    );
  }
  const resourceOptionsData = isAppointmentResourceItems && isAppointmentResourceItems.length > 0 ? isAppointmentResourceItems : null;
  const repeatsOptionsData = [
    { value: "No", label: t("No") },
    { value: "Yes", label: t("Yes") },
  ];
  const repeattimeOptionsData = [
    { value: "Weekly", label: t("Week(s)") },
    { value: "Monthly", label: t("Month(s)") },
    // { value: "Yearly", label: t("Year(s)") },
  ];
  const removeItem = (array, index) => {
    const newArray = [...array.slice(0, index), ...array.slice(index + 1)];
    return newArray;
  };
  var cancellationreasondatawithvalue = {};
  cancellationreasonObjectData.map((elm) => {
    return (cancellationreasondatawithvalue[elm.id] = elm.reason);
  });
  return (
    <>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleAppointmentSubmit}>
        {(formik) => {
          console.log('formik.values: ', formik.values);

          useEffect(() => {
            formik.setFieldValue("isDepositTabOpen", isOpenDepositPayTab)
          }, [isOpenDepositPayTab]);

          useEffect(() => {
            // Hydrated child lines carry their service price and resource
            // options in Redux, so mirror the resource requirement onto the
            // form value the child schema validates.  Multi-resource services
            // answer with grouped ``resource_requirements``, so both payload
            // shapes have to be normalized before deciding whether a resource
            // is required or unavailable.
            if (!detail) return;
            const childLines = [
              ["addonservices", isAddOn],
              ["addanotherservices", isAddAnother],
            ];
            childLines.forEach(([fieldName, options]) => {
              if (!Array.isArray(options)) return;
              options.forEach((item, index) => {
                if (!item || item.resource_options_loaded !== true) return;
                const line = formik.values[fieldName] && formik.values[fieldName][index];
                if (!line) return;
                const resourceState = childResourceOptionState(item.resource_items, item.serviceprice || {});
                const catalog = item.serviceprice;
                // A completed, matching catalog lookup can clear a hidden old
                // selection. An empty/failed availability read alone cannot.
                if (catalog && String(catalog.id) === String(line.service_id)
                  && [null, ""].includes(catalog.resource_id)
                  && !resourceState.resource_required) {
                  formik.setFieldValue(`${fieldName}.${index}.resource_id`, catalog.resource_id, false);
                  if (line.resource_item_id) formik.setFieldValue(`${fieldName}.${index}.resource_item_id`, "", false);
                  if (line.resource_allocations?.length) formik.setFieldValue(`${fieldName}.${index}.resource_allocations`, [], false);
                }
                if (line.resource_required !== resourceState.resource_required) {
                  formik.setFieldValue(`${fieldName}.${index}.resource_required`, resourceState.resource_required, false);
                }
                if (line.resource_unavailable !== resourceState.resource_unavailable) {
                  formik.setFieldValue(`${fieldName}.${index}.resource_unavailable`, resourceState.resource_unavailable, false);
                }
                if (!Array.isArray(line.resource_requirements) || line.resource_requirements.length !== resourceState.resource_requirements.length) {
                  formik.setFieldValue(`${fieldName}.${index}.resource_requirements`, resourceState.resource_requirements, false);
                }
              });
            });
          }, [detail, isAddOn, isAddAnother]);

          useEffect(() => {
            if (isStripeTokenAppointment) {
              formik.setFieldValue("stripe_token_id", isStripeTokenAppointment, true);
              formik.setFieldValue("deposit_payment_by", "StripeCreditCard", true);
            }
          }, [isStripeTokenAppointment])
          useEffect(() => {
            const remove_addon = detail?.addonservices?.length > 0
              ? detail?.addonservices.map(item => item.id)
              : [];

            const remove_addanother = detail?.addanotherservices?.length > 0
              ? detail?.addanotherservices.map(item => item.id)
              : [];
            formik.setFieldValue('remove_addon', remove_addon);
            formik.setFieldValue('remove_addanother', remove_addanother);
            // if (typeof isServicePrice !== "undefined" && Array.isArray(isServicePrice) && isServicePrice.length === 0 && detail) {
            if (detail && detail.id) {
              formik.setFieldValue("occurrence_start_datetime", formik.values.occurrence_start_datetime || detail.showstartdate || detail.start_datetime, false);
              const depositFormState = getAppointmentDepositFormState(detail);
              formik.setFieldValue("previous_deposit_paid", depositFormState.previousDepositPaid, false);
              formik.setFieldValue("totaldeposit", depositFormState.remainingDeposit, false);


              formik.setFieldValue("add_on_within_original_time", [true, 1, "1"].includes(detail.add_on_within_original_time ?? detail.service?.add_on_within_original_time), false);
              formik.setFieldValue("is_requested", formik.values.is_requested ?? isRequestedStaff(detail.is_requested), false);
              const fields = ["id", "client_id", "service_id", "staff_id", "showdate", "showstartdate", "showenddate", "start_datetime", "duration", 'padding_time', 'durationWithPadding', "cost", "repeats", "repeat_time", "repeat_time_option", "ending", "booking_notes", "status", "status_manage", "addonservices", "addanotherservices", "repeat_appointment", "resource_item_id", "resource_allocations"];

              fields.forEach((field) => {
                if (["resource_item_id", "resource_allocations"].includes(field) &&
                    String(formik.values.service_id || editDefaults.service_id) !== String(editDefaults.service_id)) return;
                if (["service_id", "staff_id"].includes(field)) {
                  const detailField = editDefaults[field];
                  formik.setFieldValue(field, formik.values[field] || detailField, false);
                } else if (field === "repeat_appointment") {
                  // Flask's persisted recurrence is authoritative even when
                  // its detail DTO has no legacy repeat marker. Derive this
                  // from the loaded record, never from the edited Repeats field.
                  formik.setFieldValue(field, isRepeatedAppointment(detail.repeat_appointment) || detail.repeats === "Yes", false);
                } else if (["showstartdate"].includes(field)) {
                  formik.setFieldValue(field, formik.values[field] ? formik.values[field] : detail[field], false);
                  formik.setFieldValue("dateof", formik.values.dateof || editDefaults.dateof, false);
                  formik.setFieldValue("start_time", formik.values.start_time || editDefaults.start_time, false);
                } else if (["showenddate", "showdate"].includes(field)) {
                  let detail_field = detail[field];
                  formik.setFieldValue(field, formik.values[field] ? formik.values[field] : detail_field, false);
                } else if (["start_datetime"].includes(field)) {
                  let detail_field = detail[field];
                  formik.setFieldValue("prev_start_datetime", formik.values[field] ? formik.values[field] : detail_field, false);
                } else if (["cost"].includes(field)) {
                  let detail_field = detail[field] ? detail[field] : "0.00";
                  formik.setFieldValue("cost", formik.values[field] ? formik.values[field] : detail_field, false);
                } else if (["ending"].includes(field)) {
                  let detail_field = detail[field] ? moment(detail[field], "YYYY-MM-DD HH:mm:ss").format("DD MMMM YYYY") : "";
                  formik.setFieldValue(field, formik.values[field] ? formik.values[field] : detail_field, false);
                } else if (["duration", "padding_time"].includes(field)) {
                  let detail_field = detail[field] > 0 ? MinutesToHours(detail[field]) : "";
                  formik.setFieldValue(field, formik.values[field] ? formik.values[field] : detail_field, false);
                } else if (["status_manage"].includes(field)) {
                  let detail_field = detail[field] ? detail[field] : "Not Started";
                  formik.setFieldValue(field, formik.values[field] ? formik.values[field] : detail_field, false);
                } else if (["status"].includes(field)) {
                  // if (detail[field] === "Confirmed") {
                  //   formik.setFieldValue(field, 1, false);
                  // } else {
                  //   formik.setFieldValue(field, "", false);
                  // }
                  let detail_field = detail[field] ? detail[field] : "";
                  formik.setFieldValue(field, formik.values[field] ? formik.values[field] : detail_field, false);
                } else if (field === "resource_allocations") {
                  const savedAllocations = Array.isArray(detail.resource_allocations) ? detail.resource_allocations : [];
                  if (savedAllocations.length && !formik.values.resource_allocations.length) {
                    formik.setFieldValue(field, savedAllocations, false);
                  }
                } else if (["addonservices"].includes(field)) {
                  if (detail[field] && detail[field].length > 0) {
                    let s = [];
                    detail[field].map((item) => {
                      let id = item.id ? item.id : "";
                      let parent_id = item.parent_id ? item.parent_id : "";
                      let service_name = item.service ? item.service.name : "";
                      const serviceFields = buildAppointmentServiceFields(item, detail.staff_id);
                      let duration = serviceFields.duration;
                      let padding_time = serviceFields.padding_time;
                      let durationWithPadding = serviceFields.durationWithPadding;
                      s.push({
                        id: id,
                        parent_id,
                        service_id: item.service_id,
                        service_name: service_name,
                        staff_id: serviceFields.staff_id,
                        resource_item_id: item.resource_item_id,
                        resource_allocations: Array.isArray(item.resource_allocations) ? item.resource_allocations : [],
                        duration: duration,
                        padding_time,
                        durationWithPadding,
                        cost: item.cost,
                        prevObj: {
                          id: id,
                          parent_id,
                          service_id: item.service_id,
                          service_name: service_name,
                          staff_id: serviceFields.staff_id,
                          resource_item_id: item.resource_item_id,
                          duration: duration,
                          padding_time,
                          durationWithPadding,
                          cost: item.cost
                        }
                      });

                    });
                    formik.setFieldValue(field, s, false);
                  }
                } else if (["addanotherservices"].includes(field)) {
                  if (detail[field] && detail[field].length > 0) {
                    let s = [];
                    detail[field].map((item) => {
                      let id = item.id ? item.id : "";
                      let parent_id = item.parent_id ? item.parent_id : "";
                      let service_name = item.service ? item.service.name : "";
                      const serviceFields = buildAppointmentServiceFields(item, detail.staff_id);
                      let duration = serviceFields.duration;
                      let padding_time = serviceFields.padding_time;
                      let durationWithPadding = serviceFields.durationWithPadding;

                      s.push({
                        id: id, parent_id,
                        service_id: item.service_id,
                        service_name: service_name,
                        staff_id: serviceFields.staff_id,
                        resource_item_id: item.resource_item_id,
                        resource_allocations: Array.isArray(item.resource_allocations) ? item.resource_allocations : [],
                        duration: duration,
                        padding_time,
                        durationWithPadding,
                        cost: item.cost,
                        prevObj: {
                          id: id, parent_id,
                          service_id: item.service_id,
                          service_name: service_name,
                          staff_id: serviceFields.staff_id,
                          resource_item_id: item.resource_item_id,
                          duration: duration,
                          padding_time,
                          durationWithPadding,
                          cost: item.cost,
                        }
                      });

                    });
                    formik.setFieldValue(field, s, false);
                  }
                } else {
                  let detail_field = detail[field] ? detail[field] : "";
                  formik.setFieldValue(field, formik.values[field] ? formik.values[field] : detail_field, false);
                  let service_id = detail && detail.service && detail.service.id ? detail.service.id : "";
                  let deposit_booked_price = depositFormState.configuredDeposit;
                  let old_cost = detail && detail.cost ? detail.cost : "0.00";
                  let addanotherObj = [{ service_id: service_id, deposit_price: deposit_booked_price, service_type: "primary", total_cost: old_cost }];
                  detail['addanotherservices'] && detail['addanotherservices'].length > 0 && detail['addanotherservices'].map((item) => {
                    let service_id = item.service_id;
                    let deposit = item.deposit;
                    let costsTotal = item.cost ? item.cost : "0.00";
                    addanotherObj.push({ service_id: service_id, deposit_price: deposit, service_type: "add_another", total_cost: costsTotal });
                  });
                  formik.setFieldValue("service_deposit", addanotherObj);
                }
              });
            }
            // else if (isServicePrice) {
            //   const duration = isServicePrice.duration ? MinutesToHours(isServicePrice.duration) : "";
            //   const padding_time = isServicePrice.padding_time ? MinutesToHours(isServicePrice.padding_time) : "";
            //   const durationWithPadding = isServicePrice && isServicePrice.padding_time && isServicePrice.padding_time > 0 ? MinutesToHours(parseInt(isServicePrice.padding_time) + parseInt(isServicePrice.duration)) : (isServicePrice && isServicePrice.duration ? MinutesToHours(isServicePrice.duration) : "")

            //   let generalPrice = isServicePrice.serviceprice;
            //   let gprice = generalPrice && generalPrice.length === 1 ? generalPrice[0].price : "0.00";
            //   let add_on_price = generalPrice && generalPrice.length === 1 ? generalPrice[0].add_on_price : "0.00";
            //   // let cost = parseFloat(gprice) + parseFloat(add_on_price);
            //   let cost = parseFloat(gprice);
            //   formik.setFieldValue("service_id", isServicePrice.id);
            //   formik.setFieldValue("duration", duration);
            //   formik.setFieldValue("padding_time", padding_time);
            //   formik.setFieldValue("durationWithPadding", durationWithPadding);
            //   formik.setFieldValue("cost", cost ? cost : "");
            // }
          }, [detail]);

          useEffect(() => {
            if (formik.values.service_resource_required || requiresAppointmentResource(isAppointmentResourceItems)) {
              formik.setFieldValue('resource_required', true)
            } else {
              formik.setFieldValue('resource_required', false)
            }
          }, [isAppointmentResourceItems, formik.values.service_resource_required])

          // useEffect(() => {
          //   if (!isStaffAvailableTimeApi) {
          //     formik.setFieldValue("start_time", "", false);
          //   }
          // }, [isStaffAvailableTimeApi]);

          useEffect(() => {
            const slot = buildAppointmentAvailabilityRequest(formik.values, {
              appointment_id: formik.values.id,
              pagetype: "edit_appointment",
              formName: "appointmentForm/edit/settled/resources",
            });
            if (!slot || !formik.values.start_time) return undefined;
            const request = buildAppointmentResourceAvailabilityRequest(slot);
            const pending = dispatch(AppointmentResourceItemsApi({
              option: { valueField: "id", labelField: "resource_item" },
              service_id: request.service_id,
              availebleTimeObj: request,
            }));
            return () => pending?.abort?.();
          }, [
            formik.values.id, formik.values.service_id, formik.values.staff_id,
            formik.values.dateof, formik.values.start_time,
            formik.values.duration, formik.values.padding_time, resourceRetry,
          ]);

          useEffect(() => {
            const request = buildAppointmentAvailabilityRequest(formik.values, {
              pagetype: "edit_appointment",
              formName: "appointmentForm/edit/settled",
            });
            if (request) GetAvailableTime(request, dispatch);
          }, [
            formik.values.service_id,
            formik.values.staff_id,
            formik.values.dateof,
            formik.values.duration,
            formik.values.padding_time,
            formik.values.resource_item_id,
          ]);

          void (totalAddonServiceDurationRef && totalAddonServiceDurationRef.current && totalAddonServiceDurationRef.current.value ? totalAddonServiceDurationRef.current.value : 0);
          return (
            <div className={"drawer client-editappoinment " + rightDrawerOpened} id="addappoinment-drawer">
              <div className="drawer-wrp">
                <form noValidate onSubmit={(event) => {
                  if (!isOpenDepositPayTab) {
                    formik.handleSubmit(event);
                    return;
                  }
                  event.preventDefault();
                  if (!validateAppointmentDeposit(formik)) return;
                  formik.validateForm().then((errors) => {
                    if (Object.keys(errors).length === 0) {
                      // Preserve the dev flow when the appointment edit is valid:
                      // save its changes before recording the deposit.
                      formik.submitForm();
                    } else {
                      // Existing incomplete appointment fields must not prevent
                      // a deposit-only payment from being recorded.
                      handleAppointmentDepositSave(formik);
                    }
                  });
                }}>
                  <div className="drawer-header">
                    <div className="d-flex align-items-baseline gap-1">
                      <h2 className="mb-4 pe-md-5 pe-3 d-flex align-items-center"> {t("Edit Appointment")}</h2>
                      <ResourceAllocationIndicator appointment={formik.values} />
                    </div>
                    <a
                      className={page && page === "calendar" ? "calendars-close-drawer cursor-pointer" : "close cursor-pointer"}
                      onClick={() => {
                        dispatch(servicePriceApi({ service_id: "" }));
                        handleEditAppointmentForm();
                      }}
                    >
                      <img src={config.imagepath + "close-icon.svg"} alt="" />
                    </a>
                  </div>
                  <div className="drawer-body pymd-5 py-3">
                    <div className="mb-3">
                      <ReactSelectField name="service_id" placeholder={t("Choose Service")} value={formik.values.service_id} options={serviceOptionsData} label={t("Service")} controlId="appointmentForm-service_id" isMulti={false} page_name={"calendar"} singlestaffaccess={singleStaffAccess} />
                    </div>
                    <div className="row gx-2">
                      <div className="col-sm-6 mb-3">
                        <RequestedStaffChoice requested={formik.values.is_requested} onChange={(requested) => formik.setFieldValue("is_requested", requested)} t={t}>
                        <ReactSelectField name="staff_id" placeholder={t("Choose Staff")} value={formik.values.staff_id} options={staffOptionsData} label={t("Staff")} controlId="appointmentForm-staff_id" isMulti={false} service_id={formik.values.service_id} />
                        </RequestedStaffChoice>
                      </div>
                      <div className="col-3 mb-3">
                        <InputField name="duration" value={formik.values.duration} label={t("Duration")} mask="99:99" controlId="appointmentForm-duration" placeholder="--:--"
                          onChange={(e) => {
                            const { value } = e.target;
                            formik.setFieldValue("duration", value);
                            if (/^\d{1,2}:\d{2}$/.test(value)) {
                              if (formik.values.service_id && value) {
                                // formik.setFieldValue("addonservices", []);
                                // formik.setFieldValue("addanotherservices", []);

                                const updatedServiceDeposit = formik.values.service_deposit && formik.values.service_deposit.length > 0 && formik.values.service_deposit.filter((item) => item.service_type != "add_another");
                                formik.setFieldValue("service_deposit", updatedServiceDeposit);

                                let totalDeposit = formik.values.totaldeposit;
                                updatedServiceDeposit && updatedServiceDeposit.length > 0 && updatedServiceDeposit.forEach((item) => {
                                  totalDeposit = parseFloat(item.deposit_price);
                                });
                                updatedServiceDeposit && updatedServiceDeposit.length > 0 && formik.setFieldValue("totaldeposit", parseFloat(totalDeposit).toFixed(2));

                                let durationWithPadding = value
                                if (formik.values.padding_time) {
                                  const duration1 = moment.duration(value);
                                  const duration2 = moment.duration(formik.values.padding_time);;

                                  const totalMinutes = duration1.asMinutes() + duration2.asMinutes();
                                  const hours = Math.floor(totalMinutes / 60);
                                  const minutes = totalMinutes % 60;

                                  const sumDuration = moment({ hours, minutes });
                                  const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                                  moment.duration(SumOfDuration);
                                  durationWithPadding = SumOfDuration
                                }
                                formik.setFieldValue("durationWithPadding", durationWithPadding);

                                // dispatch(AddOnData(""));
                              }
                            }
                          }}
                        />
                      </div>

                      <div className="col-3 mb-3">
                        <InputField name="cost" value={formik.values.cost} label={t("Cost")} controlId="appointmentForm-cost" placeholder="" />
                      </div>
                      <div className="col-4 mb-3 d-none">
                        <InputField name="padding_time" value={formik.values.padding_time} label={t("Padding")} mask="99:99" controlId="appointmentForm-padding_time" placeholder="--:--"
                          onChange={(e) => {
                            const { value } = e.target;
                            formik.setFieldValue("padding_time", value);
                            if (/^\d{1,2}:\d{2}$/.test(value) || value === "") {
                              if (formik.values.service_id) {
                                // formik.setFieldValue("addonservices", []);
                                // formik.setFieldValue("addanotherservices", []);

                                const updatedServiceDeposit = formik.values.service_deposit && formik.values.service_deposit.length > 0 && formik.values.service_deposit.filter((item) => item.service_type != "add_another");
                                formik.setFieldValue("service_deposit", updatedServiceDeposit);

                                let totalDeposit = formik.values.totaldeposit;
                                updatedServiceDeposit && updatedServiceDeposit.length > 0 && updatedServiceDeposit.forEach((item) => {
                                  totalDeposit = parseFloat(item.deposit_price);
                                });
                                updatedServiceDeposit && updatedServiceDeposit.length > 0 && formik.setFieldValue("totaldeposit", parseFloat(totalDeposit).toFixed(2));

                                let durationWithPadding = formik.values.duration;
                                if (/^\d{1,2}:\d{2}$/.test(formik.values.duration)) {
                                  const duration1 = moment.duration(formik.values.duration);;
                                  const duration2 = moment.duration(value);

                                  const totalMinutes = duration1.asMinutes() + duration2.asMinutes();
                                  const hours = Math.floor(totalMinutes / 60);
                                  const minutes = totalMinutes % 60;

                                  const sumDuration = moment({ hours, minutes });
                                  const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                                  moment.duration(SumOfDuration);
                                  durationWithPadding = SumOfDuration
                                }
                                formik.setFieldValue("durationWithPadding", durationWithPadding);

                                // dispatch(AddOnData(""));
                                dispatch(AppointmentAutoFillFinalData(""));
                              }
                            }
                          }} />
                      </div>
                    </div>
                    <div className="row gx-2">
                      <div className="col-sm-8 mb-3">
                        {/* <InputField type="date" name="date" value={formik.values.date_of_birth} label={t("Date")} controlId="appointmentForm-date" placeholder={t("Select Date")}/> */}
                        <label htmlFor="">{t("Date")}</label>
                        <DatePicker
                          weekStartDayIndex={1}
                          weekDays={config.weekDays}
                          className="purple"
                          renderButton={(direction, handleClick) => (
                            <a className="btn btn-transparent shadow-none" onClick={handleClick}>
                              {direction === "right" ? <i className="fas fa-chevron-right p-0"></i> : <i className="fas fa-chevron-left p-0"></i>}
                            </a>
                          )}
                          name="dateof"
                          id="appointmentForm-dateof"
                          value={formik.values.dateof}
                          inputClass={(formik.touched && formik.touched.dateof && formik.errors && formik.errors.dateof ? "is-invalid" : "") + " form-control date"}
                          placeholder={t("Select Date")}
                          format={"dddd, DD MMMM YYYY"}
                          // minDate={new Date().setHours(0, 0, 0, 0)}
                          onChange={(e) => {
                            let getselectedDatePicker = e ? moment(e?.toString(), "dddd, DD MMMM YYYY").format("dddd, DD MMMM YYYY") : "";
                            // let getselectedDatePicker = e ? moment(e?.toString()).format("dddd, DD MMMM YYYY") : "";
                            formik.setFieldValue("dateof", getselectedDatePicker);
                            // formik.setFieldValue("addonservices", []);
                            // formik.setFieldValue("addanotherservices", []);
                            // formik.setFieldValue("start_time", "", false);
                            const updatedServiceDeposit = formik.values.service_deposit && formik.values.service_deposit.length > 0 && formik.values.service_deposit.filter((item) => item.service_type != "add_another");
                            formik.setFieldValue("service_deposit", updatedServiceDeposit);
                            let totalDeposit = formik.values.totaldeposit;
                            updatedServiceDeposit && updatedServiceDeposit.length > 0 && updatedServiceDeposit.forEach((item) => {
                              totalDeposit = parseFloat(item.deposit_price) - parseFloat(formik.values.previous_deposit_paid);
                            });
                            updatedServiceDeposit && updatedServiceDeposit.length > 0 && formik.setFieldValue("totaldeposit", parseFloat(totalDeposit).toFixed(2));
                            // dispatch(AddOnData(""));
                            // formik.setFieldValue("addonservices", []);
                            // formik.setFieldValue("addanotherservices", []);
                          }}
                        />
                        {formik.touched && formik.touched.dateof && formik.errors && formik.errors.dateof && <div className="invalid-feedback d-block">{formik.errors.dateof}</div>}
                      </div>
                      <div className="col-sm-4 mb-3">
                        <InputPickerField
                          type="time"
                          name="start_time"
                          value={formik.values.start_time}
                          formikData={formik}
                          label={t("Start Time")}
                          controlId="appointmentForm-start_time"
                          options={TimePickerOption}
                          onChange={(e) => {
                            if (e.target.value.match(/([0-9]{1,2}):([0-9]{2})(am|pm)/)) {
                              const start_date_time = e.target.value ? moment(e.target.value, "h:mma").format("HH:mm") : "";
                              formik.setFieldValue("start_time", start_date_time, true);
                              const dateTimeString = formik.values && formik.values.dateof ? moment(formik.values.dateof, "dddd, DD MMMM YYYY").format("YYYY-MM-DD") + " " + moment(start_date_time, "HH:mm").format("HH:mm:ss") : "";

                              const TotalDurationWithPadding = GetTotalDurationWithPadding(formik.values.durationWithPadding, formik.values.addonservices, formik.values.addanotherservices, formik.values.add_on_within_original_time);
                              const obj = {
                                appointment_id: formik.values.form_types && formik.values.form_types === "edit_appointment" && formik.values.id ? formik.values.id : "",
                                busytime_id: "",
                                remove_addon: formik?.values?.remove_addon || [],
                                remove_addanother: formik?.values?.remove_addanother || [],
                                dateof: formik.values.dateof ? formik.values.dateof : "",
                                start_datetime: dateTimeString,
                                duration: formik.values.duration ? formik.values.duration : "",
                                padding_time: formik.values.padding_time ? formik.values.padding_time : "",
                                durationWithPadding: formik.values.durationWithPadding ? formik.values.durationWithPadding : "",
                                TotaldurationWithPadding: TotalDurationWithPadding && TotalDurationWithPadding.totalHours,
                                listview: "Appointment",
                                salon_id: currentUser.salon.id ? currentUser.salon.id : "",
                                service_id: formik.values.service_id ? formik.values.service_id : "",
                                staff_id: formik.values.staff_id ? formik.values.staff_id : "",
                                resource_item_id: formik.values.resource_item_id ? formik.values.resource_item_id : "",
                                uid: 1,
                                formtype: "appointmentForm",
                                formName: "appointmentForm/edit/start_time"
                              }
                              //addon and add another remove array id push logic

                              let addonservicesValues = formik.values.addonservices;
                              let addanotherservicesValues = formik.values.addanotherservices;
                              if (addonservicesValues?.length > 0) {
                                let currentRemoveAddonList = new Set(formik.values.remove_addon || []);
                                addonservicesValues.forEach(service => {
                                  if (service.id) {
                                    currentRemoveAddonList.add(service.id);
                                  }
                                });
                                formik.setFieldValue("remove_addon", Array.from(currentRemoveAddonList));
                              }
                              if (addanotherservicesValues?.length > 0) {
                                let currentRemoveAnotherList = new Set(formik.values.remove_addanother || []);
                                addanotherservicesValues.forEach(service => {
                                  console.log('service OF SET: ', service);
                                  if (service.id) {
                                    currentRemoveAnotherList.add(service.id);
                                  }
                                });
                                formik.setFieldValue("remove_addanother", Array.from(currentRemoveAnotherList));
                              }

                              //addon and add another remove array id push logic
                              dispatch(AppointmentResourceItemsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: formik.values.service_id ? formik.values.service_id : "", availebleTimeObj: obj }));
                              // formik.handleChange(e);
                            } else {
                              formik.setFieldValue("start_time", "", true);
                              // formik.handleChange(e);
                            }
                          }
                          }
                        />
                        {/* <InputField type="time" name="start_time" value={formik.values.start_time} label={t("Start Time")} controlId="appointmentForm-start_time" /> */}
                      </div>
                    </div>
                    <div className="row">
                      {appointmentApiStatus?.AppointmentResourceItemsApi === "failed" && <div className="col-12 mb-3">
                        <p role="alert" className="text-danger">{t("Unable to load resources for this appointment. Please try again.")}</p>
                        <button type="button" className="btn btn-outline-primary" onClick={() => setResourceRetry((attempt) => attempt + 1)}>{t("Retry resources")}</button>
                      </div>}
                      <AppointmentResourceFields formik={formik} response={isAppointmentResourceItems} t={t} />
                      <AppointmentResourceConflict formik={formik} response={isAppointmentResourceItems} status={appointmentApiStatus?.AppointmentResourceItemsApi} availabilityContext={appointmentResourceAvailabilityContext} staffAvailability={isStaffAvailableTimeApi} staffStatus={staffAvailabilityStatus} staffAvailabilityContext={staffAvailabilityContext} onConflictChange={setResourceConflict} t={t} />
                      {!hasRequirementResourceOptions(isAppointmentResourceItems) && isAppointmentResourceItems && isAppointmentResourceItems.length > 0 ? (
                        <div className="col-sm-12 mb-3">
                          <AppointmentSingleResourceSelection formik={formik} options={resourceOptionsData} />
                          <ReactSelectField name="resource_item_id" placeholder={t("Choose Resource")} value={formik.values.resource_item_id} options={resourceOptionsData} label={t("Resource")} controlId="appointmentForm-resource_item_id" isMulti={false} service_id={formik.values.service_id} staff_id={formik.values.staff_id} />
                        </div>
                      ) : appointmentApiStatus && appointmentApiStatus.AppointmentResourceItemsApi == "loading" && !(formik.values.resource_allocations || []).length ? (
                        <div className="col-12">
                          <label >{t("Resource")}</label>
                          <div className="placeholder-glow mb-3">
                            <span className="placeholder w-100" style={{ height: "34px", borderRadius: "4px" }}></span>
                          </div>
                        </div>
                      ) : ""}
                    </div>
                    {formik.values.service_id && formik.values.dateof && (
                      <>
                        {(AddOnServiceButtonRenders || formik.values.addonservices.length > 0) ? (
                          <FieldArray name="addonservices">
                            {({ remove, push }) => {
                              let not_service_ids = [];
                              let totaladdonservicecost = 0;
                              let totaladdonserviceduration = 0;

                              let dataRef = notServicesIdRef && notServicesIdRef.current && notServicesIdRef.current.value ? notServicesIdRef.current.value.split(",") : [];
                              const filteredData = dataRef.filter(Boolean);
                              return (
                                <div>
                                  {formik.values.addonservices &&
                                    formik.values.addonservices.length > 0 &&
                                    formik.values.addonservices.map((addonservice, index) => {
                                      let addonServiceOptionsData = isAddOn.length > 0 && isAddOn[index] ? isAddOn[index].services : null;
                                      let addonStaffOptionsData = isAddOn.length > 0 && isAddOn[index] ? isAddOn[index].staff : null;
                                      let addonResourceOptionsData = isAddOn.length > 0 && isAddOn[index] ? isAddOn[index].resource_items : null;
                                      // let addonServiceOptionsData = [];
                                      if (formik.values && formik.values.addonservices && formik.values.addonservices.length > 0 && formik.values.addonservices[index]) {
                                        not_service_ids.push(formik.values.addonservices[index].service_id);
                                      }
                                      totaladdonservicecost += formik.values.addonservices[index].cost ? parseFloat(formik.values.addonservices[index].cost) : 0;
                                      totaladdonserviceduration += formik.values.addonservices[index].duration ? HoursToMinutes(moment(formik.values.addonservices[index].duration, "HH:mm").format("HH:mm")) : 0;
                                      return (
                                        <div className="row gx-2 bg-Apricot rounded p-4 mb-2 position-relative" key={index}>
                                          <div className="position-absolute custom-position-calendar">
                                            {(activeLoading.addonLoading || AddOnLoader) && <span className="spinner-border spinner-border-sm spinner-border-color-custom"></span>}
                                          </div>
                                          <div className="col d-flex justify-content-around px-3">
                                            <div className="col-12">
                                              <h6 className="fw-bold text-white mb-2">Add an Add-On Service</h6>

                                            </div>
                                            <a
                                              className=""
                                              onClick={() => {
                                                removeChildAvailabilityRow(formik.values.form_types, "addonservices", index, dispatch);
                                                remove(index);
                                                let id = index + 1;
                                                dispatch(AddOnDataRemove({ id: id }));
                                                let addonservicesValues = formik.values.addonservices;
                                                // let currentRemoveList = [...(formik.values.remove_addon || [])];
                                                // if (addonservicesValues[index] && addonservicesValues[index].id) {
                                                //   currentRemoveList.push(addonservicesValues[index].id);
                                                // }
                                                // formik.setFieldValue("remove_addon", currentRemoveList);
                                                let currentRemoveList = [...(formik.values.remove_addon || [])];
                                                if (addonservicesValues[index] && addonservicesValues[index].id) {
                                                  const startId = addonservicesValues[index].id;
                                                  let startIndex = addonservicesValues.findIndex(item => item.id === startId);
                                                  if (startIndex !== -1) {
                                                    let idsToAdd = addonservicesValues.slice(startIndex).map(item => item.id);
                                                    idsToAdd = idsToAdd.filter(id => !currentRemoveList.includes(id));
                                                    currentRemoveList.push(...idsToAdd);
                                                  }
                                                }
                                                formik.setFieldValue("remove_addon", currentRemoveList);
                                                // addonservicesValues = addonservicesValues ? addonservicesValues.filter((item) => item.id != id) : addonservicesValues.filter((item) => item.id != id);
                                                formik.setFieldValue("addonservices", removeItem(addonservicesValues, index));
                                              }}
                                            >
                                              <i className="fas fa-times p-0" style={{ fontSize: "22px", fontWeight: "300", color: "#FFF" }}></i>
                                            </a>
                                          </div>
                                          <div className="col-md-12 mb-3">{formik.values && formik.values.addonservices && formik.values.addonservices.length > 0 && formik.values.addonservices[index] && formik.values.addonservices[index].service_id ? <span className={`${formik.values.addonservices[index].service_name ? "form-control disabled-div-style" : ""}`}>{formik.values.addonservices[index].service_name}</span> : <ReactSelectField name={`addonservices.${index}.service_id`} placeholder={t("Choose Service")} options={addonServiceOptionsData} controlId={`appointmentForm-addonservices-${index}-service_id`} isMulti={false} isAddOn={isAddOn} indexID={index + 1} />}</div>

                                          <div className="col-sm-6 mb-3">
                                            <label className="text-white fw-semibold">{t("Staff")}</label>
                                            <ReactSelectField name={`addonservices.${index}.staff_id`} placeholder={t("Choose Staff")} options={addonStaffOptionsData} label={t("")} controlId={`appointmentForm-addonservices-${index}-staff_id`} isMulti={false} service_id={formik.values.addonservices[index].service_id} isAddOn={isAddOn} indexID={index + 1} />
                                          </div>

                                          <div className="col-md-3 col-4 mb-3">
                                            <label className="text-white fw-semibold">{t("Duration")}</label>
                                            <InputField name={`addonservices.${index}.duration`} label={t("")} mask="99:99" controlId={`appointmentForm-addonservices-${index}-duration`} placeholder="--:--"
                                              onChange={(e) => {
                                                const { value } = e.target;
                                                // const formattedValue = formatCardNumber(value);
                                                formik.setFieldValue(`addonservices.${index}.duration`, value);
                                                if (/^\d{1,2}:\d{2}$/.test(value)) {
                                                  // If valid, set the result field value
                                                  if (formik.values.addonservices[index].service_id && value) {
                                                    formik.setFieldValue(`addonservices.${index}.resource_item_id`, "");
                                                    formik.values.addonservices[index].resource_item_id = ""
                                                    let durationWithPadding = value
                                                    if (formik.values && formik.values.addonservices && formik.values.addonservices[index] && formik.values.addonservices[index].padding_time) {
                                                      const duration1 = moment.duration(value);
                                                      const duration2 = moment.duration(formik.values.addonservices[index].padding_time);;

                                                      const totalMinutes = duration1.asMinutes() + duration2.asMinutes();
                                                      const hours = Math.floor(totalMinutes / 60);
                                                      const minutes = totalMinutes % 60;

                                                      const sumDuration = moment({ hours, minutes });
                                                      const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                                                      // const durationMoment = moment.duration(SumOfDuration);
                                                      durationWithPadding = SumOfDuration
                                                    }
                                                    formik.setFieldValue(`addonservices.${index}.durationWithPadding`, durationWithPadding);

                                                    const addonservices = formik.values.addonservices && formik.values.addonservices.length > 0 ? formik.values.addonservices.slice(0, index) : "";

                                                    let parentAppointmentEndTime = "";
                                                    if (addonservices && addonservices.length > 0) {
                                                      const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
                                                        // Check if sduration.durationWithPadding is a valid duration
                                                        const duration = moment.duration(sduration.durationWithPadding);
                                                        if (duration.isValid()) {
                                                          const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                                                          return sum.add(sumDurationWithPadding);
                                                        }
                                                        return sum;
                                                      }, moment.duration(0));

                                                      const parentAppointmentDuration = formik.values.durationWithPadding;
                                                      const duration1 = moment.duration(parentAppointmentDuration);
                                                      const duration2 = totalAddOnDurationWithPadding;

                                                      // Check if each duration is valid before using it
                                                      const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                                                      const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;

                                                      const totalMinutes = minutes1 + minutes2;
                                                      const hours = Math.floor(totalMinutes / 60);
                                                      const minutes = totalMinutes % 60;

                                                      const sumDuration = moment({ hours, minutes });
                                                      const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";
                                                      // console.log(SumOfDuration);
                                                      const durationMoment = moment.duration(SumOfDuration);
                                                      // appointmentStartDateTime = moment(`${form.values.dateof} ${addonservices.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                      const appointmentStartDateTime = moment(`${formik.values.dateof} ${formik.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                      appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');

                                                    } else {
                                                      const appointmentStartDateTime = moment(`${formik.values.dateof} ${formik.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                      // Parse the duration string to a moment duration
                                                      const durationMoment = moment.duration(formik.values.durationWithPadding);
                                                      appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
                                                    }

                                                    containedAppointmentChildStart(formik.values, "addonservices", index, parentAppointmentEndTime);
                                                  const obj = {
                                                      ...formik.values.addonservices[index],
                                                      remove_addon: formik?.values?.remove_addon || [],
                                                      remove_addanother: formik?.values?.remove_addanother || [],
                                                      parent_id: formik.values && formik.values.id ? formik.values.id : "",
                                                      staff_id: formik.values.addonservices[index].staff_id ? formik.values.addonservices[index].staff_id : "",
                                                      dateof: formik.values.dateof,
                                                      duration: value,
                                                      durationWithPadding: durationWithPadding,
                                                      parentAppointmentEndTime: parentAppointmentEndTime,
                                                      listview: "Appointment",
                                                      formtype: "appointmentform",
                                                      formName: "appointmentForm/edit/addonservices/duration"
                                                    }
                                                    const addOnData = isAddOn.find((event) => event.id === (index + 1));
                                                    let addonobj = { ...(addOnData || {}), id: index + 1, duration: value };
                                                    const addOnResourceOptionsAction = dispatch(AddOnResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: formik.values.addonservices[index].service_id, pagetype: "Booking", isNotInResourceIds: "", availebleTimeObj: { ...obj } }));
                                                    const addOnStaffOptionsAction = dispatch(AddonStaffOptionsApi({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, pagetype: "Booking", service_id: formik.values.addonservices[index].service_id, availebleTimeObj: { ...obj } }));
                                                    Promise.all([addOnResourceOptionsAction, addOnStaffOptionsAction]).then(([action1, action2]) => {
                                                      dispatch(AddOnData(buildAppointmentChildOptionState({
                                                        existing: addonobj,
                                                        id: index + 1,
                                                        service: formik.values.addonservices[index],
                                                        parentStaffId: formik.values.staff_id,
                                                        parentStaffOptions: staffOptionsData,
                                                        staffOptions: action2.meta.requestStatus === "fulfilled" ? action2.payload : undefined,
                                                        resourceOptions: action1.meta.requestStatus === "fulfilled" ? action1.payload : undefined,
                                                      })));
                                                    });
                                                    // dispatch(AddOnResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: formik.values.addonservices[index].service_id, pagetype: "Booking", isNotInResourceIds: "", availebleTimeObj: { ...obj } })).then((actionResource) => {
                                                    //   if (actionResource.meta.requestStatus === "fulfilled") {
                                                    //     if (addonobj) {
                                                    //       dispatch(AddOnData({ ...addonobj, resource_items: actionResource.payload }));
                                                    //     }
                                                    //   } else {
                                                    //     dispatch(AddOnData(addonobj));
                                                    //   }
                                                    // });
                                                    AddonGetAvailableTime({
                                                      availability_owner: `${formik.values.form_types}/addonservices/${index}`,
                                                      ...formik.values.addonservices[index],
                                                      remove_addon: formik?.values?.remove_addon || [],
                                                      remove_addanother: formik?.values?.remove_addanother || [],
                                                      parent_id: formik.values && formik.values.id ? formik.values.id : "",
                                                      dateof: formik.values.dateof,
                                                      duration: value,
                                                      durationWithPadding,
                                                      parentAppointmentEndTime,
                                                      listview: 'Appointment',
                                                      pagetype: "addon_appointment",
                                                      formName: "appointmentForm/edit/addonservices/duration"
                                                    }, dispatch);
                                                  }
                                                }
                                              }}
                                            />
                                          </div>
                                          <div className="col-md-2 col-4 mb-3 d-none">
                                            <label className="text-white fw-semibold">{t("Padding")}</label>
                                            <InputField name={`addonservices.${index}.padding_time`} mask="99:99" controlId={`appointmentForm-addonservices-${index}-padding_time`} placeholder="--:--"
                                              onChange={(e) => {
                                                const { value } = e.target;
                                                // const formattedValue = formatCardNumber(value);
                                                formik.setFieldValue(`addonservices.${index}.padding_time`, value);
                                                if (/^\d{1,2}:\d{2}$/.test(value) || value === "") {
                                                  // If valid, set the result field value
                                                  if (formik.values.addonservices[index].service_id) {

                                                    let durationWithPadding = formik.values.addonservices[index].duration;
                                                    if (formik.values && formik.values.addonservices && formik.values.addonservices[index] && formik.values.addonservices[index].duration) {
                                                      const duration1 = moment.duration(formik.values.addonservices[index].duration);
                                                      const duration2 = moment.duration(value);

                                                      const totalMinutes = duration1.asMinutes() + duration2.asMinutes();
                                                      const hours = Math.floor(totalMinutes / 60);
                                                      const minutes = totalMinutes % 60;

                                                      const sumDuration = moment({ hours, minutes });
                                                      const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                                                      // const durationMoment = moment.duration(SumOfDuration);
                                                      durationWithPadding = SumOfDuration
                                                    }
                                                    formik.setFieldValue(`addonservices.${index}.durationWithPadding`, durationWithPadding);

                                                    const addonservices = [...formik.values.addonservices];

                                                    let parentAppointmentEndTime = "";
                                                    if (addonservices && addonservices.length > 1) {
                                                      addonservices.pop();

                                                      const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
                                                        // Check if sduration.durationWithPadding is a valid duration
                                                        const duration = moment.duration(sduration.durationWithPadding);
                                                        if (duration.isValid()) {
                                                          const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                                                          return sum.add(sumDurationWithPadding);
                                                        }
                                                        return sum;
                                                      }, moment.duration(0));

                                                      const parentAppointmentDuration = formik.values.durationWithPadding;
                                                      const duration1 = moment.duration(parentAppointmentDuration);
                                                      const duration2 = totalAddOnDurationWithPadding;

                                                      // Check if each duration is valid before using it
                                                      const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                                                      const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;

                                                      const totalMinutes = minutes1 + minutes2;
                                                      const hours = Math.floor(totalMinutes / 60);
                                                      const minutes = totalMinutes % 60;

                                                      const sumDuration = moment({ hours, minutes });
                                                      const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";
                                                      // console.log(SumOfDuration);
                                                      const durationMoment = moment.duration(SumOfDuration);
                                                      // appointmentStartDateTime = moment(`${form.values.dateof} ${addonservices.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                      const appointmentStartDateTime = moment(`${formik.values.dateof} ${formik.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                      appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');

                                                    } else {
                                                      const appointmentStartDateTime = moment(`${formik.values.dateof} ${formik.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                      // Parse the duration string to a moment duration
                                                      const durationMoment = moment.duration(formik.values.durationWithPadding);
                                                      appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
                                                    }
                                                    containedAppointmentChildStart(formik.values, "addonservices", index, parentAppointmentEndTime);
                                                  const obj = {
                                                      ...formik.values.addonservices[index],
                                                      remove_addon: formik?.values?.remove_addon || [],
                                                      remove_addanother: formik?.values?.remove_addanother || [],
                                                      parent_id: formik.values && formik.values.id ? formik.values.id : "",
                                                      staff_id: formik.values.addonservices[index].staff_id ? formik.values.addonservices[index].staff_id : "",
                                                      dateof: formik.values.dateof,
                                                      padding_time: value,
                                                      durationWithPadding: durationWithPadding,
                                                      parentAppointmentEndTime: parentAppointmentEndTime,
                                                      listview: "Appointment",
                                                      formtype: "appointmentform",
                                                      formName: "appointmentForm/edit/addonservices/padding_time"
                                                    }
                                                    const addOnData = isAddOn.find((event) => event.id === (index + 1));
                                                    let addonobj = { ...addOnData, duration: formik.values.addonservices[index].duration };
                                                    dispatch(AddOnResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: formik.values.addonservices[index].service_id, pagetype: "Booking", isNotInResourceIds: "", availebleTimeObj: { ...obj } })).then((actionResource) => {
                                                      if (actionResource.meta.requestStatus === "fulfilled") {
                                                        if (addonobj) {
                                                          dispatch(AddOnData({ ...addonobj, resource_items: actionResource.payload }));
                                                        }
                                                      } else {
                                                        dispatch(AddOnData(addonobj));
                                                      }
                                                    });
                                                    AddonGetAvailableTime({
                                                      availability_owner: `${formik.values.form_types}/addonservices/${index}`,
                                                      ...formik.values.addonservices[index],
                                                      remove_addon: formik?.values?.remove_addon || [],
                                                      remove_addanother: formik?.values?.remove_addanother || [],
                                                      dateof: formik.values.dateof,
                                                      padding_time: value,
                                                      durationWithPadding,
                                                      parentAppointmentEndTime,
                                                      listview: 'Appointment',
                                                      pagetype: "addon_appointment",
                                                      formName: "appointmentForm/edit/addonservices/padding_time"
                                                    }, dispatch);
                                                  }
                                                }
                                              }}

                                            />
                                          </div>
                                          <div className="col-md-3 col-4 mb-3">
                                            <label className="text-white fw-semibold">{t("Cost")}</label>
                                            <InputField name={`addonservices.${index}.cost`} label={t("")} controlId={`appointmentForm-addonservices-${index}-cost`} placeholder="" />
                                          </div>
                                          {hasRequirementResourceOptions(isAddOn[index]?.resource_items) ? (
                                            <div className="col-sm-12 mb-3">
                                              <AppointmentResourceFields formik={formik} fieldName={`addonservices.${index}`} response={isAddOn[index].resource_items} t={t} />
                                              {formik.values.addonservices[index]?.resource_unavailable && !hasResourceConfigurationProblem(isAddOn[index].resource_items) && (
                                                <div className="text-danger" role="alert">{additionalServiceResourceUnavailableMessage(t)}</div>
                                              )}
                                            </div>
                                          ) : isAddOn.length > 0 && isAddOn[index] && isAddOn[index].resource_items && isAddOn[index].resource_items.length > 0 ? (
                                            <div className="col-sm-12 mb-3">
                                              <label className="text-white fw-semibold">{t("Resource")}</label>
                                              <AppointmentSingleResourceSelection formik={formik} fieldName={`addonservices.${index}`} options={addonResourceOptionsData} />
                                              <ReactSelectField name={`addonservices.${index}.resource_item_id`} placeholder={t("Choose Resource")} options={addonResourceOptionsData} controlId={`appointmentForm-addonservices-${index}-resource_item_id`} isMulti={false} service_id={formik.values.addonservices[index].service_id} staff_id={formik.values.addonservices[index].staff_id} isAddOn={isAddOn} indexID={index + 1} />
                                            </div>
                                          ) : isAddOnApiStatus && isAddOnApiStatus.AddOnResourceOptionsApi == "loading" ? (
                                            <div className="col-sm-12 mb-3">
                                              <label className="text-white fw-semibold">{t("Resource")}</label>
                                              <div className="box-image-cover notification-boxs w-100 mx-0 px-2 py-2 text-start">
                                                <div className="col-12 placeholder-glow">
                                                  <BarLoader color="#ffc1b0" className="w-100" height={"18px"} />
                                                </div>
                                              </div>
                                            </div>
                                          ) : formik.values.addonservices[index] && (formik.values.addonservices[index].resource_unavailable || formik.values.addonservices[index].resource_required) ? (
                                            <div className="col-sm-12 mb-3 text-danger" role="alert">
                                              {additionalServiceResourceUnavailableMessage(t)}
                                            </div>
                                          ) : ""}

                                          {/* <div className="col">
                                  <label htmlFor={`addonservices.${index}.service_id`}>Service</label>
                                  <Field name={`addonservices.${index}.service_id`} placeholder="Jane Doe" type="text" />
                                  <ErrorMessage name={`addonservices.${index}.service_id`} component="div" className="field-error" />
                                </div>
                                <div className="col">
                                  <label htmlFor={`addonservices.${index}.staff_id`}>Staff</label>
                                  <Field name={`addonservices.${index}.staff_id`} placeholder="jane@acme.com" type="text" />
                                  <ErrorMessage name={`addonservices.${index}.staff_id`} component="div" className="field-error" />
                                </div> */}
                                          {/* <div className="position-absolute custom-bar-loader-calendar">
                                            <BarLoader color="#8c1c4d" className="w-100" />
                                          </div> */}
                                        </div>
                                      );
                                    })}
                                  <input ref={notServicesIdRef} type="hidden" value={not_service_ids} />
                                  <input ref={totalAddonServiceCostRef} type="hidden" value={totaladdonservicecost} />
                                  <input ref={totalAddonServiceDurationRef} type="hidden" value={totaladdonserviceduration} />
                                  {AddOnServiceButtonRenders && filteredData.length == formik.values.addonservices.length && (
                                    <button
                                      type="button"
                                      className="btn btn-cancel bg-Apricot col-12 me-1 cursor-pointer mb-3 fw-semibold text-light-whites"
                                      onClick={() => {
                                        if (notServicesIdRef && notServicesIdRef.current) {
                                        }
                                        push({ service_id: "", staff_id: "", resource_item_id: "", duration: "", cost: "" });
                                        // dispatch(AddOnData(addOnData));
                                        dispatch(AddOnServicesApi({ service_id: formik.values.service_id, isNotId: not_service_ids })).then((action) => {
                                          if (action.meta.requestStatus === "fulfilled") {
                                            // addOnData.services = action.payload;
                                            let addOnData = { id: formik.values.addonservices.length + 1, parent_id: formik.values.id, serviceprice: "", services: [], resource_items: [], staff: [], duration: "", cost: "" };
                                            dispatch(AddOnData({ ...addOnData, services: action.payload }));
                                          }
                                        });
                                      }}
                                    >
                                      {t("Add an Add-On Service")}
                                    </button>
                                  )}
                                </div>
                              );
                            }}
                          </FieldArray>
                        ) : ""}
                        <FieldArray name="addanotherservices">
                          {({ remove, push }) => {
                            let not_service_ids = [];
                            let totaladdanotherservicecost = 0;
                            let totaladdanotherserviceduration = 0;
                            let dataRef = notAnotherServicesIdRef && notAnotherServicesIdRef.current && notAnotherServicesIdRef.current.value ? notAnotherServicesIdRef.current.value.split(",") : [];
                            const filteredData = dataRef.filter(Boolean);
                            return (
                              <div>
                                {formik.values.addanotherservices.length > 0 &&
                                  formik.values.addanotherservices.map((addanotherservice, index) => {
                                    let addonServiceOptionsData = isAddAnother.length > 0 && isAddAnother[index] ? isAddAnother[index].services : null;
                                    let addonStaffOptionsData = isAddAnother.length > 0 && isAddAnother[index] ? isAddAnother[index].staff : null;
                                    let addanotherResourceOptionsData = isAddAnother.length > 0 && isAddAnother[index] ? isAddAnother[index].resource_items : null;
                                    // let addonServiceOptionsData = [];
                                    if (formik.values && formik.values.addanotherservices && formik.values.addanotherservices.length > 0 && formik.values.addanotherservices[index]) {
                                      not_service_ids.push(formik.values.addanotherservices[index].service_id);
                                    }
                                    totaladdanotherservicecost += formik.values.addanotherservices[index].cost ? parseFloat(formik.values.addanotherservices[index].cost) : 0;

                                    totaladdanotherserviceduration += formik.values.addanotherservices[index].duration ? HoursToMinutes(moment(formik.values.addanotherservices[index].duration, "HH:mm").format("HH:mm")) : 0;

                                    return (
                                      <div className="row gx-2 bg-pink rounded p-4 mb-2 position-relative" key={index}>
                                        <div className="position-absolute custom-position-calendar">
                                          {(activeLoading.addanotherLoading || AddAnotherLoader) && <span className="spinner-border spinner-border-sm spinner-border-color-custom"></span>}
                                        </div>
                                        <div className="col d-flex justify-content-around px-3">
                                          <div className="col-12">
                                            <h6 className="fw-bold mb-2" style={{ color: "#6b7280" }}>Add Another Service</h6>
                                          </div>
                                          <a
                                            className=""
                                            onClick={() => {
                                              removeChildAvailabilityRow(formik.values.form_types, "addanotherservices", index, dispatch);
                                              remove(index);
                                              let id = index + 1;
                                              dispatch(AddAnotherDataRemove({ id: id }));
                                              let addanotherservicesValues = formik.values.addanotherservices;
                                              let currentRemoveList = [...(formik.values.remove_addanother || [])];
                                              if (addanotherservicesValues[index] && addanotherservicesValues[index].id) {
                                                const startId = addanotherservicesValues[index].id;
                                                let startIndex = addanotherservicesValues.findIndex(item => item.id === startId);
                                                if (startIndex !== -1) {
                                                  let idsToAdd = addanotherservicesValues.slice(startIndex).map(item => item.id);
                                                  idsToAdd = idsToAdd.filter(id => !currentRemoveList.includes(id));
                                                  currentRemoveList.push(...idsToAdd);
                                                }
                                              }
                                              formik.setFieldValue("remove_addanother", currentRemoveList);
                                              formik.setFieldValue("addanotherservices", removeItem(addanotherservicesValues, index));
                                              const updatedServiceDeposit = formik.values.service_deposit.filter((item) => item.service_id !== addanotherservice.service_id);
                                              formik.setFieldValue("service_deposit", updatedServiceDeposit);
                                              const DepositDeductionData = addanotherservice && addanotherservice.service_id && formik.values.service_deposit && formik.values.service_deposit.length > 0 && formik.values.service_deposit.find((item) => item.service_id === addanotherservice.service_id)
                                              if (DepositDeductionData && parseFloat(formik.values.totaldeposit) - parseFloat(DepositDeductionData.deposit_price) > 0) {
                                                formik.setFieldValue("totaldeposit", (parseFloat(formik.values.totaldeposit) - parseFloat(DepositDeductionData.deposit_price)).toFixed(2));
                                              } else if (DepositDeductionData && parseFloat(formik.values.totaldeposit) - parseFloat(DepositDeductionData.deposit_price) <= 0) {
                                                dispatch(OpenDepositPayTab(false));
                                                formik.setFieldValue("totaldeposit", 0);
                                              }
                                            }}
                                          >
                                            <i className="fas fa-times p-0" style={{ fontSize: "22px", fontWeight: "300", color: "#999999" }}></i>
                                          </a>
                                        </div>
                                        <div className="col-md-12 mb-3">{formik.values && formik.values.addanotherservices && formik.values.addanotherservices.length > 0 && formik.values.addanotherservices[index] && formik.values.addanotherservices[index].service_id ? <span className={`${formik.values.addanotherservices[index].service_name ? "form-control disabled-div-style" : ""}`}>{formik.values.addanotherservices[index].service_name}</span> : <ReactSelectField name={`addanotherservices.${index}.service_id`} placeholder={t("Choose Service")} options={addonServiceOptionsData} controlId={`appointmentForm-addanotherservices-${index}-service_id`} isMulti={false} isAddAnother={isAddAnother} indexID={index + 1} />}</div>

                                        <div className="col-sm-6 mb-3">
                                          <ReactSelectField name={`addanotherservices.${index}.staff_id`} placeholder={t("Choose Staff")} options={addonStaffOptionsData} label={t("Staff")} controlId={`appointmentForm-addanotherservices-${index}-staff_id`} isMulti={false} service_id={formik.values.addanotherservices[index].service_id} isAddAnother={isAddAnother} indexID={index + 1} />
                                        </div>

                                        <div className="col-md-3 col-4 mb-3">
                                          <InputField name={`addanotherservices.${index}.duration`} label={t("Duration")} mask="99:99" controlId={`appointmentForm-addanotherservices-${index}-duration`} placeholder="--:--"
                                            onChange={(e) => {
                                              const { value } = e.target;
                                              // const formattedValue = formatCardNumber(value);
                                              formik.setFieldValue(`addanotherservices.${index}.duration`, value);
                                              if (/^\d{1,2}:\d{2}$/.test(value)) {
                                                // console.log('duration', formik.values);
                                                // If valid, set the result field value
                                                if (formik.values.addanotherservices[index].service_id && value) {
                                                  formik.setFieldValue(`addanotherservices.${index}.resource_item_id`, "");
                                                  formik.values.addanotherservices[index].resource_item_id = ""
                                                  let durationWithPadding = value
                                                  if (formik.values && formik.values.addanotherservices && formik.values.addanotherservices[index] && formik.values.addanotherservices[index].padding_time) {
                                                    const duration1 = moment.duration(value);
                                                    const duration2 = moment.duration(formik.values.addanotherservices[index].padding_time);

                                                    const totalMinutes = duration1.asMinutes() + duration2.asMinutes();
                                                    const hours = Math.floor(totalMinutes / 60);
                                                    const minutes = totalMinutes % 60;

                                                    const sumDuration = moment({ hours, minutes });
                                                    const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                                                    // const durationMoment = moment.duration(SumOfDuration);
                                                    durationWithPadding = SumOfDuration
                                                  }
                                                  formik.setFieldValue(`addanotherservices.${index}.durationWithPadding`, durationWithPadding);

                                                  const addonservices = formik.values.addonservices && formik.values.addonservices.length > 0 ? formik.values.addonservices.slice(0, index + 1) : "";
                                                  const addanotherservices = formik.values.addanotherservices && formik.values.addanotherservices.length > 0 ? formik.values.addanotherservices.slice(0, index) : "";
                                                  let parentAppointmentEndTime = "";
                                                  const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
                                                    // Check if sduration.durationWithPadding is a valid duration
                                                    const duration = moment.duration(sduration.durationWithPadding);
                                                    if (duration.isValid()) {
                                                      const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                                                      return sum.add(sumDurationWithPadding);
                                                    }
                                                    return sum;
                                                  }, moment.duration(0));

                                                  if (addanotherservices && addanotherservices.length > 0) {
                                                    const totalAddAnotherDurationWithPadding = addanotherservices.length > 0 && addanotherservices.reduce((sum, sduration) => {
                                                      // Check if sduration.durationWithPadding is a valid duration
                                                      const duration = moment.duration(sduration.durationWithPadding);
                                                      if (duration.isValid()) {
                                                        const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                                                        return sum.add(sumDurationWithPadding);
                                                      }
                                                      return sum;
                                                    }, moment.duration(0));

                                                    const parentAppointmentDuration = formik.values.durationWithPadding;
                                                    const duration1 = moment.duration(parentAppointmentDuration);
                                                    const duration2 = totalAddOnDurationWithPadding;
                                                    const duration3 = totalAddAnotherDurationWithPadding;

                                                    // Check if each duration is valid before using it
                                                    const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                                                    const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;
                                                    const minutes3 = duration3 && duration3.isValid() ? duration3.asMinutes() : 0;

                                                    const totalMinutes = minutes1 + minutes2 + minutes3;
                                                    const hours = Math.floor(totalMinutes / 60);
                                                    const minutes = totalMinutes % 60;

                                                    const sumDuration = moment({ hours, minutes });
                                                    const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";
                                                    // console.log(SumOfDuration);
                                                    const durationMoment = moment.duration(SumOfDuration);
                                                    // appointmentStartDateTime = moment(`${form.values.dateof} ${addanotherservicesPrevObj.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                    const appointmentStartDateTime = moment(`${formik.values.dateof} ${formik.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                    appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');

                                                  } else {
                                                    const appointmentStartDateTime = moment(`${formik.values.dateof} ${formik.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                    // Parse the duration string to a moment duration
                                                    const duration1 = moment.duration(formik.values.durationWithPadding);
                                                    const duration2 = totalAddOnDurationWithPadding;

                                                    // Check if each duration is valid before using it
                                                    const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                                                    const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;

                                                    const totalMinutes = minutes1 + minutes2;
                                                    const hours = Math.floor(totalMinutes / 60);
                                                    const minutes = totalMinutes % 60;

                                                    const sumDuration = moment({ hours, minutes });
                                                    const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                                                    const durationMoment = moment.duration(SumOfDuration);
                                                    // Add the duration to the date and time
                                                    appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
                                                  }
                                                  containedAppointmentChildStart(formik.values, "addanotherservices", index, parentAppointmentEndTime);
                                                  const obj = {
                                                    ...formik.values.addanotherservices[index],
                                                    remove_addon: formik?.values?.remove_addon || [],
                                                    remove_addanother: formik?.values?.remove_addanother || [],
                                                    parent_id: formik.values && formik.values.id ? formik.values.id : "",
                                                    staff_id: formik.values.addanotherservices[index].staff_id ? formik.values.addanotherservices[index].staff_id : "",
                                                    dateof: formik.values.dateof,
                                                    duration: value,
                                                    durationWithPadding: durationWithPadding,
                                                    parentAppointmentEndTime: parentAppointmentEndTime,
                                                    listview: "Appointment",
                                                    formtype: "appointmentform",
                                                    formName: "appointmentForm/edit/addanotherservices/duration"
                                                  }

                                                  const addAnotherData = isAddAnother.find((event) => event.id === (index + 1));

                                                  let addanotherobj = { ...(addAnotherData || {}), id: index + 1, duration: value };
                                                  const addAnotherResourceOptionsAction = dispatch(AddAnotherResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: formik.values.addanotherservices[index].service_id, pagetype: "Booking", isNotInResourceIds: "", availebleTimeObj: { ...obj } }));
                                                  const addAnotherStaffOptionsAction = dispatch(AddAnotherStaffOptionsApi({ option: { valueField: "users.id", labelField: "CONCAT(users.first_name,' ',users.last_name)" }, service_id: formik.values.addanotherservices[index].service_id, pagetype: "Booking", availebleTimeObj: { ...obj } }));
                                                  Promise.all([addAnotherResourceOptionsAction, addAnotherStaffOptionsAction]).then(([action1, action2]) => {
                                                    dispatch(AddAnotherData(buildAppointmentChildOptionState({
                                                      existing: addanotherobj,
                                                      id: index + 1,
                                                      service: formik.values.addanotherservices[index],
                                                      parentStaffId: formik.values.staff_id,
                                                      parentStaffOptions: staffOptionsData,
                                                      staffOptions: action2.meta.requestStatus === "fulfilled" ? action2.payload : undefined,
                                                      resourceOptions: action1.meta.requestStatus === "fulfilled" ? action1.payload : undefined,
                                                    })));
                                                  });

                                                  // dispatch(AddAnotherResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: formik.values.addanotherservices[index].service_id, pagetype: "Booking", isNotInResourceIds: "", availebleTimeObj: { ...obj } })).then((actionResource) => {
                                                  //   if (actionResource.meta.requestStatus === "fulfilled") {
                                                  //     if (addAnotherData) {
                                                  //       dispatch(AddAnotherData({ ...addAnotherData, resource_items: actionResource.payload }));
                                                  //     }
                                                  //   } else {
                                                  //     dispatch(AddAnotherData(addanotherobj));
                                                  //   }
                                                  // });
                                                  AddAnotherGetAvailableTime({
                                                    availability_owner: `${formik.values.form_types}/addanotherservices/${index}`,
                                                    ...formik.values.addanotherservices[index],
                                                    remove_addon: formik?.values?.remove_addon || [],
                                                    remove_addanother: formik?.values?.remove_addanother || [],
                                                    parent_id: formik.values && formik.values.id ? formik.values.id : "",
                                                    dateof: formik.values.dateof,
                                                    duration: value,
                                                    durationWithPadding,
                                                    parentAppointmentEndTime,
                                                    listview: 'Appointment',
                                                    pagetype: "addanother_appointment",
                                                    formName: "appointmentForm/edit/addanotherservices/duration"
                                                  }, dispatch);
                                                }
                                              }
                                            }}
                                          />
                                        </div>
                                        <div className="col-md-2 col-4 mb-3 d-none">
                                          <InputField name={`addanotherservices.${index}.padding_time`} label={t("Padding")} mask="99:99" controlId={`appointmentForm-addanotherservices-${index}-padding_time`} placeholder="--:--"
                                            onChange={(e) => {
                                              const { value } = e.target;
                                              // const formattedValue = formatCardNumber(value);
                                              formik.setFieldValue(`addanotherservices.${index}.padding_time`, value);
                                              if (/^\d{1,2}:\d{2}$/.test(value) || value === "") {
                                                // console.log('duration', formik.values);
                                                // If valid, set the result field value
                                                if (formik.values.addanotherservices[index].service_id) {
                                                  let durationWithPadding = formik.values.addanotherservices[index].duration

                                                  if (formik.values && formik.values.addanotherservices && formik.values.addanotherservices[index] && formik.values.addanotherservices[index].padding_time) {
                                                    const duration1 = moment.duration(formik.values.addanotherservices[index].duration);
                                                    const duration2 = moment.duration(value);

                                                    const totalMinutes = duration1.asMinutes() + duration2.asMinutes();
                                                    const hours = Math.floor(totalMinutes / 60);
                                                    const minutes = totalMinutes % 60;

                                                    const sumDuration = moment({ hours, minutes });
                                                    const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                                                    // const durationMoment = moment.duration(SumOfDuration);
                                                    durationWithPadding = SumOfDuration
                                                  }
                                                  formik.setFieldValue(`addanotherservices.${index}.durationWithPadding`, durationWithPadding);

                                                  const addonservices = [...formik.values.addonservices];
                                                  const addanotherservices = [...formik.values.addanotherservices];
                                                  let parentAppointmentEndTime = "";

                                                  const totalAddOnDurationWithPadding = addonservices && addonservices.length > 0 && addonservices.reduce((sum, sduration) => {
                                                    // Check if sduration.durationWithPadding is a valid duration
                                                    const duration = moment.duration(sduration.durationWithPadding);
                                                    if (duration.isValid()) {
                                                      const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                                                      return sum.add(sumDurationWithPadding);
                                                    }
                                                    return sum;
                                                  }, moment.duration(0));

                                                  if (addanotherservices && addanotherservices.length > 1) {
                                                    addanotherservices.pop();

                                                    const totalAddAnotherDurationWithPadding = addanotherservices.length > 0 && addanotherservices.reduce((sum, sduration) => {
                                                      // Check if sduration.durationWithPadding is a valid duration
                                                      const duration = moment.duration(sduration.durationWithPadding);
                                                      if (duration.isValid()) {
                                                        const sumDurationWithPadding = moment.duration(sduration.durationWithPadding);
                                                        return sum.add(sumDurationWithPadding);
                                                      }
                                                      return sum;
                                                    }, moment.duration(0));

                                                    const parentAppointmentDuration = formik.values.durationWithPadding;
                                                    const duration1 = moment.duration(parentAppointmentDuration);
                                                    const duration2 = totalAddOnDurationWithPadding;
                                                    const duration3 = totalAddAnotherDurationWithPadding;

                                                    // Check if each duration is valid before using it
                                                    const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                                                    const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;
                                                    const minutes3 = duration3 && duration3.isValid() ? duration3.asMinutes() : 0;

                                                    const totalMinutes = minutes1 + minutes2 + minutes3;
                                                    const hours = Math.floor(totalMinutes / 60);
                                                    const minutes = totalMinutes % 60;

                                                    const sumDuration = moment({ hours, minutes });
                                                    const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";
                                                    // console.log(SumOfDuration);
                                                    const durationMoment = moment.duration(SumOfDuration);
                                                    // appointmentStartDateTime = moment(`${form.values.dateof} ${addanotherservicesPrevObj.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                    const appointmentStartDateTime = moment(`${formik.values.dateof} ${formik.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                    appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');

                                                  } else {
                                                    const appointmentStartDateTime = moment(`${formik.values.dateof} ${formik.values.start_time}`, "dddd, DD MMMM YYYY HH:mm");
                                                    // Parse the duration string to a moment duration
                                                    const duration1 = moment.duration(formik.values.durationWithPadding);
                                                    const duration2 = totalAddOnDurationWithPadding;
                                                    // Check if each duration is valid before using it
                                                    const minutes1 = duration1 && duration1.isValid() ? duration1.asMinutes() : 0;
                                                    const minutes2 = duration2 && duration2.isValid() ? duration2.asMinutes() : 0;

                                                    const totalMinutes = minutes1 + minutes2;
                                                    const hours = Math.floor(totalMinutes / 60);
                                                    const minutes = totalMinutes % 60;

                                                    const sumDuration = moment({ hours, minutes });
                                                    const SumOfDuration = sumDuration ? sumDuration.format('HH:mm') : "";

                                                    const durationMoment = moment.duration(SumOfDuration);
                                                    // Add the duration to the date and time
                                                    appointmentStartDateTime.clone().add(durationMoment).format('YYYY-MM-DD HH:mm:00');
                                                  }
                                                  containedAppointmentChildStart(formik.values, "addanotherservices", index, parentAppointmentEndTime);
                                                  const obj = {
                                                    ...formik.values.addanotherservices[index],
                                                    remove_addon: formik?.values?.remove_addon || [],
                                                    remove_addanother: formik?.values?.remove_addanother || [],
                                                    parent_id: formik.values && formik.values.id ? formik.values.id : "",
                                                    staff_id: formik.values.addanotherservices[index].staff_id ? formik.values.addanotherservices[index].staff_id : "",
                                                    dateof: formik.values.dateof,
                                                    padding_time: value,
                                                    durationWithPadding: durationWithPadding,
                                                    parentAppointmentEndTime: parentAppointmentEndTime,
                                                    listview: "Appointment",
                                                    formtype: "appointmentform",
                                                    formName: "appointmentForm/edit/addanotherservices/padding_time"
                                                  }
                                                  const addAnotherData = isAddAnother.find((event) => event.id === formik.values.addanotherservices[index].id);
                                                  let addanotherobj = {
                                                    ...(addAnotherData || {}),
                                                    id: formik.values.addanotherservices[index].id || index + 1,
                                                    duration: formik.values.addanotherservices[index].duration,
                                                    padding_time: value,
                                                    durationWithPadding,
                                                  };
                                                  dispatch(AddAnotherResourceOptionsApi({ option: { valueField: "id", labelField: "resource_item" }, service_id: formik.values.addanotherservices[index].service_id, pagetype: "Booking", isNotInResourceIds: "", availebleTimeObj: { ...obj } })).then((actionResource) => {
                                                    if (actionResource.meta.requestStatus === "fulfilled") {
                                                      if (addAnotherData) {
                                                        dispatch(AddAnotherData({ ...addAnotherData, resource_items: actionResource.payload }));
                                                      }
                                                    } else {
                                                      dispatch(AddAnotherData(addanotherobj));
                                                    }
                                                  });
                                                  AddAnotherGetAvailableTime({
                                                    availability_owner: `${formik.values.form_types}/addanotherservices/${index}`,
                                                    ...formik.values.addanotherservices[index],
                                                    remove_addon: formik?.values?.remove_addon || [],
                                                    remove_addanother: formik?.values?.remove_addanother || [],
                                                    dateof: formik.values.dateof,
                                                    padding_time: value,
                                                    durationWithPadding,
                                                    parentAppointmentEndTime,
                                                    listview: 'Appointment',
                                                    pagetype: "addanother_appointment",
                                                    formName: "appointmentForm/edit/addanotherservices/padding_time"
                                                  }, dispatch);
                                                }
                                              }
                                            }}
                                          />
                                        </div>
                                        <div className="col-md-3 col-4 mb-3">
                                          <InputField name={`addanotherservices.${index}.cost`} label={t("Cost")} controlId={`appointmentForm-addanotherservices-${index}-cost`} placeholder="" />
                                        </div>
                                        {hasRequirementResourceOptions(isAddAnother[index]?.resource_items) ? (
                                          <div className="col-sm-12 mb-3">
                                            <AppointmentResourceFields formik={formik} fieldName={`addanotherservices.${index}`} response={isAddAnother[index].resource_items} t={t} />
                                            {formik.values.addanotherservices[index]?.resource_unavailable && !hasResourceConfigurationProblem(isAddAnother[index].resource_items) && (
                                              <div className="text-danger" role="alert">{additionalServiceResourceUnavailableMessage(t)}</div>
                                            )}
                                          </div>
                                        ) : isAddAnother.length > 0 && isAddAnother[index] && isAddAnother[index].resource_items && isAddAnother[index].resource_items.length > 0 ? (
                                          <div className="col-sm-12 mb-3">
                                            <AppointmentSingleResourceSelection formik={formik} fieldName={`addanotherservices.${index}`} options={addanotherResourceOptionsData} />
                                            <ReactSelectField name={`addanotherservices.${index}.resource_item_id`} placeholder={t("Choose Resource")} label={t("Resource")} options={addanotherResourceOptionsData} controlId={`appointmentForm-addanotherservices-${index}-resource_item_id`} isMulti={false} service_id={formik.values.addanotherservices[index].service_id} staff_id={formik.values.addanotherservices[index].staff_id} isAddOn={isAddOn} indexID={index + 1} />
                                          </div>
                                        ) : isAddAnotherApiStatus && isAddAnotherApiStatus.AddAnotherResourceOptionsApi == "loading" ? (
                                          <div className="col-sm-12 mb-3">
                                            <label className="fw-semibold">{t("Resource")}</label>
                                            <div className="box-image-cover notification-boxs w-100 mx-0 px-2 py-2 text-start">
                                              <div className="col-12 placeholder-glow">
                                                <BarLoader color="#f4eeeb" className="w-100" height={"18px"} />
                                              </div>
                                            </div>
                                          </div>
                                        ) : formik.values.addanotherservices[index].resource_unavailable ? (
                                          <div className="col-sm-12 mb-3 text-danger" role="alert">
                                            {additionalServiceResourceUnavailableMessage(t)}
                                          </div>
                                        ) : ""}

                                        {/* <div className="col">
                             <label htmlFor={`addanotherservices.${index}.service_id`}>Service</label>
                             <Field name={`addanotherservices.${index}.service_id`} placeholder="Jane Doe" type="text" />
                             <ErrorMessage name={`addanotherservices.${index}.service_id`} component="div" className="field-error" />
                           </div>
                           <div className="col">
                             <label htmlFor={`addanotherservices.${index}.staff_id`}>Staff</label>
                             <Field name={`addanotherservices.${index}.staff_id`} placeholder="jane@acme.com" type="text" />
                             <ErrorMessage name={`addanotherservices.${index}.staff_id`} component="div" className="field-error" />
                           </div> */}
                                      </div>
                                    );
                                  })}
                                <input ref={notAnotherServicesIdRef} type="hidden" value={not_service_ids} />
                                <input ref={totalAddanotherServiceCostRef} type="hidden" value={totaladdanotherservicecost} />
                                <input ref={totalAddanotherServiceDurationRef} type="hidden" value={totaladdanotherserviceduration} />
                                {filteredData.length == formik.values.addanotherservices.length && (
                                  <button
                                    type="button"
                                    className="btn btn-cancel col-12 me-1 cursor-pointer mb-3"
                                    onClick={() => {
                                      if (notAnotherServicesIdRef && notAnotherServicesIdRef.current) {
                                      }
                                      push(buildEmptyAdditionalServiceLine(formik.values.staff_id));
                                      // dispatch(AddAnotherData(addOnData));
                                      dispatch(AddAnotherServicesApi({ service_id: formik.values.service_id, isNotId: not_service_ids, fieldtype: "addanother" })).then((action) => {
                                        if (action.meta.requestStatus === "fulfilled") {
                                          // addOnData.services = action.payload;
                                          let addOnData = { id: formik.values.addanotherservices.length + 1, parent_id: formik.values.id, serviceprice: "", services: [], staff: [], duration: "", cost: "" };
                                          dispatch(AddAnotherData({ ...addOnData, services: action.payload, fieldtype: "addanother" }));
                                        }
                                      });
                                    }}
                                  >
                                    {t("Add Another Service")}
                                  </button>
                                )}
                              </div>
                            );
                          }}
                        </FieldArray>
                      </>
                    )}
                    <div className="mb-3">
                      <SelectField name="repeats" value={formik.values.repeats} options={repeatsOptionsData} label={t("Repeats")} controlId="appointmentForm-repeats" />
                      {/* <a href="#" className="btn btn-outline-primary mt-3">
                        Add Another Service
                      </a> */}
                    </div>
                    {formik.values.repeats === "Yes" && isRepeatedAppointment(formik.values.repeat_appointment) && formik.values.occurrence_start_datetime && (
                      <div className="mb-3">
                        <SelectField name="edit_scope" value={formik.values.edit_scope} options={[
                          { value: "individual", label: t("Only this appointment") },
                          { value: "future", label: t("This and future appointments") },
                        ]} label={t("Apply changes to")} controlId="appointmentForm-edit_scope" />
                      </div>
                    )}
                    {formik.values.repeats && formik.values.repeats === "Yes" && (
                      <div className="row mb-3">
                        <div className="col-6">
                          <div className="col-12">
                            <label className="mb-0">{t("Repeat this every")}</label>
                          </div>
                          <div className="row">
                            <div className="col-md-4">
                              <InputField type="text" name="repeat_time" value={formik.values.repeat_time} label={""} controlId="busytimeForm-repeat_time" />
                            </div>
                            <div className="col-md-8">
                              <SelectField name="repeat_time_option" placeholder={t("--Select--")} value={formik.values.repeat_time_option} options={repeattimeOptionsData} label={""} controlId="busytimeForm-repeat_time_option" />
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <label htmlFor="busytimeForm-ending">{t("Ending")}</label>
                          <DatePicker
                            weekStartDayIndex={1}
                            weekDays={config.weekDays}
                            className="purple"
                            renderButton={(direction, handleClick) => (
                              <a className="btn btn-transparent shadow-none" onClick={handleClick}>
                                {direction === "right" ? <i className="fas fa-chevron-right p-0"></i> : <i className="fas fa-chevron-left p-0"></i>}
                              </a>
                            )}
                            name="ending"
                            id="busytimeForm-ending"
                            value={formik.values.ending}
                            inputClass={"form-control ending"}
                            placeholder={t("Select Date")}
                            format={"DD MMMM YYYY"}
                            minDate={formik.values.dateof ? moment(formik.values.dateof).add(9, "days").toDate() : new Date()}
                            onChange={(e) => {
                              let getselectedDatePicker = e ? moment(e?.toString(), "DD MMMM YYYY").format("DD MMMM YYYY") : "";
                              formik.setFieldValue("ending", getselectedDatePicker);
                            }}
                          />
                          {formik.touched && formik.touched.ending && formik.errors && formik.errors.ending && <div className="invalid-feedback d-block">{formik.errors.ending}</div>}
                        </div>
                      </div>
                    )}
                    <div className="mb-3">
                      <ClientBookingNote note={detail?.client_booking_notes} />
                      <TextareaField {...getAppointmentNotesFieldProps({ locked: detail?.status === "Completed" })} type="text" name="booking_notes" placeholder={t("Add any notes about the appointment")} value={formik.values.booking_notes} label={t("Booking notes")} controlId="appointmentForm-booking_notes" />
                    </div>
                    {parseFloat(depositBalance) > 0 && (
                      <a className="btn bg-beige w-100 color-wine mb-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="font-bold mb-0">Deposit Paid</h5>
                          <h5 className="font-bold mb-0">${depositBalance}</h5>
                        </div>
                      </a>
                    )}
                    {openStripeSetupModal && (
                      <>
                        <div className={openStripeSetupModal ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: openStripeSetupModal ? "block" : "none" }}>
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                              <div className="modal-body pb-0">
                                <div className="p-3">
                                  <h5 className="mb-3 fw-semibold text-dark">{t("Online Payment")}</h5>
                                  <p className="fw-semibold mb-2">Connect your <span className="color-wine font-semibold text-decoration-underline cursor-pointer" onClick={() => navigate("/settings?tab=Integrations")}>Stripe account</span> to accept online bookings and payments.</p>
                                </div>
                                <div className="row mt-3 bg-cream p-4 justify-content-center">
                                  <div className="col-6">
                                    <button className="btn btn-primary w-100" onClick={() => {
                                      setOpenStripeSetupModal(false);
                                    }} type="button">
                                      {t("OK")}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {openStripeSetupModal && <div className="modal-backdrop show"></div>}
                      </>
                    )}
                    {openConfirmationModal && (
                      <>
                        <div className={openConfirmationModal ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: openConfirmationModal ? "block" : "none" }}>
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                              <div className="modal-body pb-0">
                                <div className="p-3">
                                  <h5 className="mb-3 fw-semibold text-dark">{t("Confirm Payment")}</h5>
                                  <p className="fw-semibold mb-2">{t(`Are you sure you want to confirm this payment ${paymentMethodConfirmationLabel(isCalendarEditFormSetActivebtnState)} ?`)}</p>
                                </div>
                                <div className="row mt-3 bg-cream p-4 justify-content-center">
                                  <div className="col-6">
                                    <button className="preview btn me-1 cursor-pointer btn-preview w-100" type="button" onClick={() => {
                                      setOpenConfirmationModal(false);
                                    }}>
                                      {t("Cancel")}
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button className="btn btn-primary w-100" onClick={() => {
                                      if (isCalendarEditFormSetActivebtnState === "CreditCard") {
                                        dispatch(GetStripeTokenAppointment(""))
                                        formik.setFieldValue("deposit_payment_by", "CreditCard", true)
                                        formik.setFieldValue("stripe_token_id", "", true)
                                        setOpenConfirmationModal(false);
                                      } else if (isCalendarEditFormSetActivebtnState === "Cash") {
                                        dispatch(GetStripeTokenAppointment(""))
                                        formik.setFieldValue("deposit_payment_by", "Cash", true)
                                        formik.setFieldValue("stripe_token_id", "", true)
                                        setOpenConfirmationModal(false);
                                      } else if (isCalendarEditFormSetActivebtnState === "BankTransfer") {
                                        dispatch(GetStripeTokenAppointment(""))
                                        formik.setFieldValue("deposit_payment_by", "BankTransfer", true)
                                        formik.setFieldValue("stripe_token_id", "", true)
                                        setOpenConfirmationModal(false);
                                      } else if (isCalendarEditFormSetActivebtnState === "Voucher") {
                                        dispatch(GetStripeTokenAppointment(""))
                                        formik.setFieldValue("deposit_payment_by", "Voucher", true)
                                        formik.setFieldValue("stripe_token_id", "", true)
                                        dispatch(ClientVoucherListViewApi({
                                          client_id: formik.values.client_id || detail?.client_id,
                                          limit: 100,
                                        }))
                                        setOpenConfirmationModal(false);
                                      }
                                    }} type="button">
                                      {t("Confirm")}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {openConfirmationModal && <div className="modal-backdrop show"></div>}
                      </>
                    )}
                    {!(isOpenDepositPayTab) ? (
                      <>
                        <a className="btn bg-beige w-100 cursor-default color-wine mb-2">
                          <div className="d-flex align-items-center justify-content-between">
                            <h6 className="font-bold text-dark mb-0">Deposit</h6>
                            <h6 className="color-wine mb-0 text-decoration-underline cursor-pointer" onClick={() => {
                              dispatch(OpenDepositPayTab(true));
                              setBtnConfirmation(false);
                              if (formik.values.totaldeposit !== null && formik.values.totaldeposit !== undefined && !isNaN(parseFloat(formik.values.totaldeposit)) && parseFloat(formik.values.totaldeposit) > 0) {
                              } else {
                                formik.setFieldValue("totaldeposit", 0, false)
                              }
                            }}>Add Deposit</h6>
                          </div>
                        </a>
                        {/* <button
                        type="button"
                        className="btn btn-apricots w-100"
                        onClick={() => {
                          dispatch(OpenDepositPayTab(true));
                          setBtnConfirmation(false);
                        }}
                      >
                        {t("Add Deposit")}
                      </button>*/}
                      </>
                    ) : ""}
                    {isOpenDepositPayTab ? (
                      <div className="row gx-2 bg-beige rounded p-4 mb-2">
                        <div className="pay-card-details-wr">
                          {/* <label htmlFor="" className="text-dark fw-semibold">Card Details</label> */}
                          <div className="col-12 mb-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="input-deposit-label">
                                <label htmlFor="appointmentForm-deposit">Remaining Deposit</label>
                              </div>
                              <div className="remove-deposits">
                                <a className="color-wine text-decoration-underline cursor-pointer" onClick={() => {
                                  dispatch(OpenDepositPayTab(false));
                                  formik.setFieldValue("deposit_payment_by", "", true);
                                  formik.setFieldValue("voucher_to_id", "", true);
                                  formik.setFieldValue("stripe_token_id", "", true);
                                  dispatch(GetStripeTokenAppointment(""));
                                  setBtnConfirmation(true);
                                }}>Remove deposit</a>
                              </div>
                            </div>
                            <Field type='text' name="totaldeposit" className='form-control' value={formik.values.totaldeposit} id="appointmentForm-deposit"
                              onKeyDown={(e) => {
                                if (e.key === '-' || e.key === 'Minus') {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                const sanitizedInput = inputValue.replace(/[^0-9.-]/g, '');
                                const firstMinusIndex = sanitizedInput.indexOf('-');
                                const hasMultipleMinus = firstMinusIndex !== -1 && sanitizedInput.indexOf('-', firstMinusIndex + 1) !== -1;
                                const numericInput = hasMultipleMinus ? sanitizedInput.replace(/-/g, '').replace('-', '') : sanitizedInput;
                                formik.setFieldValue("totaldeposit", numericInput);
                              }}
                            />
                            {/* <InputField type="text" name="totaldeposit" value={formik.values.totaldeposit} controlId="appointmentForm-deposit" /> */}
                            <ErrorMessage name="totaldeposit" component="div" className="text-danger mt-1" />
                          </div>
                          <div className="appointment-deposit-methods">
                            <div>
                              <button type="button" className={`btn ${formik.values.deposit_payment_by === "StripeCreditCard" ? "btn-primary" : "btn-dark"} w-100`} onClick={() => {
                                if (currentUser && currentUser.salon && currentUser.salon.is_stripe_verify == 1) {
                                  dispatch(CalendarEditFormSetActivebtnState(""));
                                  dispatch(OpenInvoiceStripePayModal({state: "open", client_id: formik.values.client_id}));
                                } else {
                                  setOpenStripeSetupModal(true);
                                }
                              }}>
                                <i className="fas fa-bolt" aria-hidden="true" />{t("Pay with Stripe")}
                              </button>
                            </div>
                            <div>
                              <button type="button" className={`btn ${formik.values.deposit_payment_by === "CreditCard" ? "btn-primary" : "btn-dark"} w-100`} onClick={() => {
                                setOpenConfirmationModal(true);
                                dispatch(CalendarEditFormSetActivebtnState("CreditCard"));
                              }}>
                                <i className="far fa-credit-card" aria-hidden="true" />{t("Paid by Card")}
                              </button>
                            </div>
                            <div>
                              <button type="button" className={`btn ${formik.values.deposit_payment_by === "Cash" ? "btn-primary" : "btn-dark"} w-100`} onClick={() => {
                                setOpenConfirmationModal(true);
                                dispatch(CalendarEditFormSetActivebtnState("Cash"));
                              }}>
                                <i className="fas fa-money-bill-wave" aria-hidden="true" />{t("Paid by Cash")}
                              </button>
                            </div>
                            <div>
                              <button type="button" className={`btn ${formik.values.deposit_payment_by === "BankTransfer" ? "btn-primary" : "btn-dark"} w-100`} onClick={() => {
                                setOpenConfirmationModal(true);
                                dispatch(CalendarEditFormSetActivebtnState("BankTransfer"));
                              }}>
                                <i className="fas fa-university" aria-hidden="true" />{t("Paid by Bank Transfer")}
                              </button>
                            </div>
                            <div>
                              <button type="button" className={`btn ${formik.values.deposit_payment_by === "Voucher" ? "btn-primary" : "btn-dark"} w-100`} onClick={() => {
                                setOpenConfirmationModal(true);
                                dispatch(CalendarEditFormSetActivebtnState("Voucher"));
                              }}>
                                <i className="fas fa-ticket-alt" aria-hidden="true" />{t("Paid by Voucher")}
                              </button>
                            </div>
                          </div>
                          {formik.values.deposit_payment_by === "Voucher" ? (
                            <div className="row mt-3">
                              <div className="col-12">
                                <label htmlFor="appointmentForm-voucher" className="text-dark fw-semibold">{t("Voucher code")}</label>
                                <div className="d-flex gap-2">
                                  <input id="appointmentForm-voucher" className="form-control" value={voucherCode} placeholder={t("e.g. GIFT-4821")} onChange={(event) => { setVoucherCode(event.target.value); setVoucherCodeError(""); formik.setFieldValue("voucher_to_id", "", false); }} />
                                  <button type="button" className="btn btn-primary" onClick={() => {
                                    const voucher = findEligibleAppointmentVoucherByCode(appointmentVoucherOptions, voucherCode);
                                    if (!voucher) {
                                      setVoucherCodeError(t("Voucher code is unavailable for this client."));
                                      return;
                                    }
                                    formik.setFieldValue("voucher_to_id", voucher.id, true);
                                    setVoucherCodeError("");
                                  }}>{t("Apply")}</button>
                                </div>
                                {formik.values.voucher_to_id ? <p className="text-success mt-1 mb-0">{appointmentVoucherLabel(appointmentVoucherOptions.find((voucher) => String(voucher.id) === String(formik.values.voucher_to_id)))}</p> : null}
                                {voucherCodeError ? <p className="text-danger mt-1 mb-0" role="alert">{voucherCodeError}</p> : null}
                                {appointmentVoucherOptions.length === 0 ? (
                                  <p className="text-danger mt-1 mb-0">{t("No eligible vouchers are available for this client.")}</p>
                                ) : null}
                                <ErrorMessage name="voucher_to_id" component="div" className="text-danger mt-1" />
                              </div>
                            </div>
                          ) : ""}
                          <ErrorMessage name="deposit_payment_by" component="div" className="text-danger mt-1" />
                        </div>
                      </div>
                    ) : ""}
                    {formik.status && formik.status.warning && <p className="text-danger mb-0 pt-1 pb-1"> {formik.status.warning}</p>}
                  </div>
                  <div className="drawer-footer pt-0">
                    <div className="row justify-content-between mt-3 mb-lg-2">
                      <div className="col-auto h5 mb-3 fw-semibold">
                        {/* {(getHours(formik.values.duration, "H:m") || getMinutes(formik.values.duration, "H:m")) &&
                          t("Total of {{hour}}hr {{minute}}minutes", {
                            hour: getHours(moment(formik.values.duration, "HH:mm").add(totalAddonServiceDuration, "minutes").format("HH:mm"), "H:m"),
                            minute: getMinutes(moment(formik.values.duration, "HH:mm").add(totalAddonServiceDuration, "minutes").format("HH:mm"), "H:m"),
                          })} */}
                        {(() => {
                          let totalDuration = 0;
                          if (formik.values.duration && /^\d{2}:\d{2}$/.test(formik.values.duration)) {
                            const [hours, minutes] = formik.values.duration.split(':');
                            totalDuration += parseInt(hours) * 60 + parseInt(minutes);
                          }

                          if (!formik.values.add_on_within_original_time && formik.values.addonservices && formik.values.addonservices.length > 0) {
                            formik.values.addonservices.forEach((service) => {
                              const duration = (service.duration && /^\d{2}:\d{2}$/.test(service.duration)) ? service.duration : '00:00';
                              const [hours, minutes] = duration.split(':');
                              totalDuration += (parseInt(hours) || 0) * 60 + (parseInt(minutes) || 0);
                            });
                          }

                          if (formik.values.addanotherservices && formik.values.addanotherservices.length > 0) {
                            formik.values.addanotherservices.forEach((service) => {
                              const duration = (service.duration && /^\d{2}:\d{2}$/.test(service.duration)) ? service.duration : '00:00';
                              const [hours, minutes] = duration.split(':');
                              totalDuration += (parseInt(hours) || 0) * 60 + (parseInt(minutes) || 0);
                            });
                          }

                          // Calculate total hours and minutes
                          const totalHours = Math.floor(totalDuration / 60);
                          const totalMinutes = totalDuration % 60;

                          // Format the total duration
                          return `Total of ${totalHours} hr ${totalMinutes} minutes`;
                        })()}
                      </div>
                      <div className="col-auto h5 mb-3 fw-semibold float-end">
                        ${(() => {
                          let totalCost = 0;

                          // Calculate total cost from the main appointment
                          if (!isNaN(parseFloat(formik.values.cost))) {
                            totalCost += parseFloat(formik.values.cost);
                          }

                          // Calculate total cost from addonservices
                          if (formik.values.addonservices && formik.values.addonservices.length > 0) {
                            formik.values.addonservices.forEach((service) => {
                              if (!isNaN(parseFloat(service.cost))) {
                                totalCost += parseFloat(service.cost);
                              }
                            });
                          }

                          // Calculate total cost from addanotherservices
                          if (formik.values.addanotherservices && formik.values.addanotherservices.length > 0) {
                            formik.values.addanotherservices.forEach((service) => {
                              if (!isNaN(parseFloat(service.cost))) {
                                totalCost += parseFloat(service.cost);
                              }
                            });
                          }

                          // Display the total cost
                          return totalCost.toFixed(2); // Ensure the total cost is displayed with 2 decimal places
                        })()}
                      </div>
                      {/* <div className="col-auto h5 mb-3 fw-semibold float-end">${formik.values.cost ? parseFloat(formik.values.cost) + parseFloat(totalAddonServiceCostRef && totalAddonServiceCostRef.current && totalAddonServiceCostRef.current.value && totalAddonServiceCostRef.current.value) : "00.00"}</div> */}
                    </div>
                    {/* MY CUSTOM MODAL */}
                    <div className={showModal ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: showModal ? "block" : "none" }}>
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                          <div className="modal-body pb-0">
                            <div className="p-3">
                              {confirmedRefund ? (
                                <>
                                  <div className="d-flex justify-content-between">
                                    <h5 className="mb-3 fw-semibold text-dark">{t("Initiate Refund?")}</h5>
                                    <a onClick={() => {
                                      setConfirmedRefund(false);
                                    }}>
                                      <i className="fas fa-times p-0" style={{ fontSize: "22px", fontWeight: "300", color: "#8c1c4d" }}></i>
                                    </a>
                                  </div>
                                  <p className="fw-semibold mb-2">{t("Do you want to initiate a refund for this cancelled appointment?")}</p>
                                </>
                              ) : (
                                <>
                                  <h5 className="mb-3 fw-semibold text-dark">{t("Are you sure you want to cancel this appointment?")}</h5>
                                  <div className="col-12 mb-2">
                                    <select
                                      name="cancellation_reason"
                                      className="form-control"
                                      value={selectedCancellationReason}
                                      onChange={(e) => {
                                        setSelectedCancellationReason(e.target.value);
                                        setShowError(false);
                                      }}
                                    >
                                      <option value="">{t("--Reason for Cancellation--")}</option>
                                      {cancellationreasonObjectData.map((reason) => (
                                        <option key={reason.id} value={reason.id}>
                                          {reason.reason}
                                        </option>
                                      ))}
                                    </select>
                                    {showError && !selectedCancellationReason && <p className="mb-0 text-danger">Please select a cancellation reason</p>}
                                  </div>
                                </>
                              )}
                            </div>
                            {confirmedRefund ? (
                              <div className="row mt-3 bg-cream p-4 justify-content-center">
                                <div className="col-6">
                                  <button className="btn btn-primary w-100" type="button" onClick={() => {
                                    dispatch(GetAppointmentcancelRefundStripe(""));
                                    dispatch(CancellationReason({ selectedCancellationReason: selectedCancellationReason, isRangeInfo: isRangeInfo, depositBalance: depositBalance }));
                                    dispatch(EditAppointmentFormData(formik.values));
                                    setShowModal(false);
                                    setConfirmedRefund(false);
                                    dispatch(OpenEditAppointmentRefunds("open"));
                                  }}>
                                    {t("Yes")}
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    className="preview btn me-1 cursor-pointer btn-preview w-100"
                                    onClick={() => {
                                      const cancellation_reason = selectedCancellationReason;
                                      if (!cancellation_reason || cancellation_reason === "") {
                                        setShowError(true);
                                      } else {
                                        const cancellationValues = {
                                          id: formik.values.id,
                                          client_id: formik.values.client_id,
                                          status: "Cancelled",
                                          clickEvent: "statusupdate",
                                          cancellation_reason: cancellation_reason,
                                        };
                                        setLoading(true);
                                        dispatch(appointmentUpdateApi(cancellationValues)).then((action) => {
                                          setLoading(false); // Hide the loading spinner
                                          if (action.meta.requestStatus === "fulfilled") {
                                            const payload = action.payload;
                                            dispatch(AppointmentDetailModal(""));
                                            formik.setStatus({ success: true });
                                            formik.resetForm();
                                            dispatch(servicePriceApi({ service_id: "" }));
                                            dispatch(AppointmentDetailModal(""));
                                            dispatch(EditAppointmentForm());
                                            dispatch(ClientAppointmentListViewApi({ client: detail.id, client_id: detail.id, filter: isFilter, page_name: "client_appointment" }));
                                            if (isRangeInfo) {
                                              dispatch(appointmentFrameRefreshApi({ range: isRangeInfo, appointments: [cancellationValues, payload] }));
                                              dispatch(appointmentDetailApi(buildAppointmentDetailRefreshPayload({
                                                values: cancellationValues,
                                                response: payload,
                                                detail,
                                              })));
                                            }
                                            customToast.success(`${t("Appointment booking Cancelled")}`);
                                          } else {
                                            customToast.error(t("Error occurred during cancellation"));
                                          }
                                        });
                                        setShowModal(false);
                                      }
                                    }}
                                    type="button"
                                    disabled={loading}
                                  >
                                    {loading && <span className="spinner-border spinner-border-sm"></span>}
                                    {t("No")}
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="row mt-3 bg-cream p-4 justify-content-center">
                                <div className="col-6">
                                  <button className="preview btn me-1 cursor-pointer btn-preview w-100" type="button" onClick={() => setShowModal(false)}>
                                    {t("Cancel")}
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    className="btn btn-primary w-100"
                                    onClick={() => {
                                      const cancellation_reason = selectedCancellationReason;
                                      if (!cancellation_reason || cancellation_reason === "") {
                                        setShowError(true);
                                      } else {
                                        if (!confirmedRefund && depositBalance && depositBalance > 0) {
                                          setConfirmedRefund(true);
                                        } else {
                                          const cancellationValues = {
                                            id: formik.values.id,
                                            client_id: formik.values.client_id,
                                            status: "Cancelled",
                                            clickEvent: "statusupdate",
                                            cancellation_reason: cancellation_reason,
                                          };
                                          setLoading(true);
                                          dispatch(appointmentUpdateApi(cancellationValues)).then((action) => {
                                            setLoading(false); // Hide the loading spinner
                                            if (action.meta.requestStatus === "fulfilled") {
                                              const payload = action.payload;
                                              dispatch(AppointmentDetailModal(""));
                                              formik.setStatus({ success: true });
                                              formik.resetForm();
                                              dispatch(servicePriceApi({ service_id: "" }));
                                              dispatch(EditAppointmentForm());
                                              dispatch(ClientAppointmentListViewApi({ client: detail.id, client_id: detail.id, filter: isFilter, page_name: "client_appointment" }));
                                              if (isRangeInfo) {
                                                dispatch(appointmentFrameRefreshApi({ range: isRangeInfo, appointments: [cancellationValues, payload] }));
                                                dispatch(appointmentDetailApi(buildAppointmentDetailRefreshPayload({
                                                  values: cancellationValues,
                                                  response: payload,
                                                  detail,
                                                })));
                                              }
                                              customToast.success(`${t("Appointment booking Cancelled")}`);
                                            } else {
                                              customToast.error(t("Error occurred during cancellation"));
                                            }
                                          });
                                          setShowModal(false);
                                        }
                                      }
                                    }}
                                    type="button"
                                    disabled={loading}
                                  >
                                    {loading && <span className="spinner-border spinner-border-sm"></span>}
                                    {t("Confirm")}
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {showModal && <div className="modal-backdrop show"></div>}
                    <div className="row">
                      <div className="col-6">
                        <button
                          type="button"
                          className="btn btn-danger w-100 btn-lg"
                          disabled={loading}
                          onClick={() => {
                            dispatch(CancellationreasonListViewApi())
                            setShowModal(true);
                            // console.log("Cancellation Reason Data:", cancellationreasondatawithvalue); // Add this console log
                            // let confirmbtn = swalConfirmInput(e.currentTarget, { title: t("Are you sure you want to cancel the appointment?"), message: "", confirmButtonText: t("Yes, cancelled it!"), options: cancellationreasondatawithvalue });

                            // if (confirmbtn == true) {
                            //   let cancellation_reason = e.target.getAttribute("reason");
                            //   dispatch(appointmentUpdateApi({ id: formik.values.id, client_id: formik.values.client_id, status: "Cancelled", clickEvent: "statusupdate", cancellation_reason: cancellation_reason })).then((action) => {
                            //     if (action.meta.requestStatus === "fulfilled") {
                            //       formik.setStatus({ success: true });
                            //       formik.resetForm();
                            //       dispatch(servicePriceApi({ service_id: "" }));
                            //       dispatch(EditAppointmentForm());
                            //       dispatch(ClientAppointmentListViewApi({ client: detail.id }));
                            //       if (isRangeInfo) {
                            //         dispatch(appointmentListViewApi(isRangeInfo));
                            // dispatch(appointmentDetailApi({ id: detail.id, client_id: detail.client_id, showdate: detail.showdate }));
                            //       }
                            //       customToast.success(`${t("Appointment booking Cancelled")}`);
                            //     }
                            //   });
                            // }
                          }}
                        >
                          {loading && <span className="spinner-border spinner-border-sm"></span>}
                          {t("Cancel Appointment")}
                        </button>
                      </div>
                      <div className="col-6">
                        <button type="submit" className="btn btn-appointments btn-primary w-100 btn-lg" disabled={loading || resourceConflict || resourceLookupBlocked || hasUnavailableAdditionalServiceResources(formik.values)}>
                          {loading && <span className="spinner-border spinner-border-sm"></span>}
                          {t("Save Appointment")}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          );
        }}
      </Formik>
    </>
  );
};
AppointmentEditForm.propTypes = {
  isRangeInfo: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
  page: PropTypes.string,
};
export default AppointmentEditForm;
